export const logoIcon = (
  <svg
    width={133}
    height={32}
    viewBox="0 0 133 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_569_15614)">
      <path
        d="M16 19.126c-.783 0-1.15-.486-1.15-.486-1.952-1.697-7.743-1.455-7.743-1.455L4.69 10.1s6.851.665 10.16 2.938c0 0 .367.486 1.15.486.782 0 1.148-.486 1.148-.486 3.31-2.273 10.16-2.938 10.16-2.938l-2.416 7.085s-5.789-.241-7.744 1.455c0 0-.366.486-1.149.486z"
        fill="#F5ECEB"
      />
      <path
        d="M16 20.444c-.85 0-1.247-.526-1.247-.526-2.12-1.843-8.404-1.58-8.404-1.58l-2.625-7.653s7.437.182 11.029 2.652c0 0 .397.526 1.246.526.85 0 1.247-.526 1.247-.526 3.592-2.467 11.03-2.652 11.03-2.652l-2.626 7.653s-6.284-.263-8.404 1.58c0 0-.397.526-1.246.526z"
        fill="#F5ECEB"
      />
      <path
        d="M15.999 22.897c-.967 0-1.422-.6-1.422-.6-2.419-2.102-9.586-1.803-9.586-1.803L2 12.244v-.525s8.48-.675 12.58 2.14c0 0 .454.6 1.421.6.967 0 1.422-.6 1.422-.6 4.096-2.815 12.58-2.14 12.58-2.14v.524l-2.994 8.251s-7.165-.301-9.584 1.802c0 0-.455.6-1.421.6h-.005z"
        fill="#F5ECEB"
      />
      <path
        d="M17.42 14.382s-.454.6-1.421.6c-.967 0-1.422-.6-1.422-.6C10.481 11.568 2 12.242 2 12.242l2.994 8.778s.04 0 .107-.005l-.01.005c10.712.472 10.795 6.73 10.788 7.17.014-.44.417-6.7 11.127-7.17L30 12.243s-8.48-.675-12.58 2.14z"
        fill="#931400"
      />
      <path
        d="M20.548 15.142l-.452 1.996c2.177-.873 5.06-.99 6.61-.979l.67-1.78s-3.957-.268-6.828.763z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M15.633 5.175c.897.871 1.63 2.027 1.972 3.559.203-.307.385-.656.529-1.075.966-2.814 1.964-3.369 3.302-3.25 0 0-3.336-.956-5.803.766z"
        fill="#FAFBFC"
      />
      <path
        d="M16.504 12.452C18.544 4.404 10.58 4 10.58 4c1.304.32 2.068 1.17 2.065 4.145 0 2.974 2.458 3.883 2.458 3.883s.612.352 1.4.424z"
        fill="#23D58B"
      />
      <path
        d="M17.42 14.383s-.454.6-1.42.6c-.908 0-1.357-.521-1.41-.586.067.981.5 7.516.452 10.996.823 1.387.84 2.613.838 2.8.007-.19.086-1.436 1.005-2.844.002-3.701.5-10.294.552-10.976l-.014.01h-.002z"
        fill="#fff"
      />
    </g>
    <path
      d="M38 21.79V5.726h10.673v2.587h-7.74v4.118h7.31v2.588h-7.31v4.183h7.74v2.588H38zM49.53 21.79l4.097-5.887-4.119-5.843h3.321l3.213 4.743h-1.488l3.213-4.743h3.299l-4.097 5.843 4.075 5.887h-3.299l-3.17-4.723h1.445l-3.17 4.723h-3.32zM65.957 22.048c-.819 0-1.53-.136-2.134-.41-.604-.273-1.071-.66-1.402-1.164-.33-.517-.496-1.114-.496-1.79 0-.646.144-1.221.431-1.724.288-.518.734-.95 1.337-1.294.604-.345 1.366-.59 2.286-.733l3.838-.626v2.157l-3.299.56c-.56.1-.977.28-1.25.54-.274.258-.41.596-.41 1.013 0 .402.15.726.453.97.316.23.704.345 1.164.345.59 0 1.107-.122 1.553-.366.46-.26.812-.611 1.056-1.057.259-.446.388-.934.388-1.466v-3.019c0-.503-.201-.92-.604-1.25-.388-.346-.905-.518-1.552-.518a2.76 2.76 0 00-1.617.496 2.77 2.77 0 00-1.014 1.272l-2.307-1.121c.23-.618.59-1.15 1.078-1.596a5.51 5.51 0 011.768-1.078 6.099 6.099 0 012.2-.388c.963 0 1.811.18 2.544.539.733.345 1.301.834 1.703 1.466.417.618.626 1.344.626 2.178v7.806h-2.674v-2.006l.604-.043a4.912 4.912 0 01-1.078 1.272c-.417.331-.892.59-1.423.777a5.71 5.71 0 01-1.769.258zM74.908 21.79V10.06h2.652v2.716l-.302-.452c.216-.848.647-1.481 1.294-1.898.646-.417 1.408-.625 2.285-.625.963 0 1.811.251 2.545.755.733.503 1.207 1.164 1.423 1.983l-.798.065c.36-.934.898-1.632 1.617-2.092.719-.474 1.546-.711 2.48-.711.834 0 1.574.187 2.22.56a3.989 3.989 0 011.553 1.574c.374.662.56 1.43.56 2.308v7.547h-2.824V14.91c0-.517-.093-.963-.28-1.337a2.06 2.06 0 00-.776-.862c-.331-.216-.734-.324-1.208-.324a2.19 2.19 0 00-1.186.324c-.345.201-.61.489-.798.862-.186.374-.28.82-.28 1.337v6.879H82.26V14.91c0-.517-.093-.963-.28-1.337a2.016 2.016 0 00-.798-.862c-.33-.216-.726-.324-1.186-.324-.445 0-.84.108-1.186.324-.345.201-.61.489-.797.862-.187.374-.28.82-.28 1.337v6.879h-2.825z"
      fill="#fff"
    />
    <path
      d="M93.75 21.79L99.29 5.726h3.795l5.542 16.064h-3.192l-1.142-3.45h-6.21l-1.165 3.45h-3.17zm5.174-6.038h4.529l-2.674-8h.819l-2.674 8zM110.178 21.79V5.467h2.825V21.79h-2.825zM115.611 21.79V5.467h2.825V21.79h-2.825zM122.467 26.533c-.316 0-.625-.028-.927-.086a2.498 2.498 0 01-.82-.259v-2.35c.187.043.41.086.669.13.273.043.524.064.754.064.647 0 1.115-.15 1.402-.453.302-.287.568-.675.798-1.164l.776-1.811-.043 2.372-5.11-12.916h3.04l3.579 9.53h-1.078l3.558-9.53h3.062l-5.11 12.915c-.302.748-.669 1.388-1.1 1.92a4.317 4.317 0 01-1.509 1.207c-.561.288-1.208.431-1.941.431z"
      fill="#BE1A00"
    />
  </svg>
);

export const admiLogo = (
  <svg
    width={133}
    height={32}
    viewBox="0 0 133 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_6814_8987)">
      <path
        d="M16 19.126c-.783 0-1.15-.486-1.15-.486-1.952-1.697-7.743-1.455-7.743-1.455L4.69 10.1s6.851.665 10.16 2.938c0 0 .367.486 1.15.486.782 0 1.148-.486 1.148-.486 3.31-2.273 10.16-2.938 10.16-2.938l-2.417 7.085s-5.788-.241-7.743 1.455c0 0-.366.486-1.149.486z"
        fill="#F5ECEB"
      />
      <path
        d="M16 20.444c-.85 0-1.248-.526-1.248-.526-2.12-1.843-8.404-1.58-8.404-1.58l-2.625-7.652s7.438.182 11.03 2.651c0 0 .397.527 1.246.527.85 0 1.247-.527 1.247-.527 3.592-2.467 11.03-2.651 11.03-2.651l-2.626 7.653s-6.284-.264-8.404 1.579c0 0-.397.526-1.247.526z"
        fill="#FFC8C0"
      />
      <path
        d="M15.999 22.897c-.967 0-1.422-.6-1.422-.6-2.419-2.102-9.586-1.802-9.586-1.802L2 12.244v-.524s8.48-.675 12.58 2.139c0 0 .454.6 1.421.6.967 0 1.422-.6 1.422-.6 4.096-2.814 12.58-2.14 12.58-2.14v.525l-2.994 8.25s-7.165-.3-9.584 1.803c0 0-.455.6-1.421.6h-.005z"
        fill="#FFA395"
      />
      <path
        d="M17.42 14.383s-.454.6-1.421.6c-.967 0-1.422-.6-1.422-.6C10.481 11.569 2 12.243 2 12.243l2.994 8.778s.04 0 .107-.005l-.01.005c10.712.471 10.795 6.73 10.788 7.17.014-.44.417-6.7 11.127-7.17L30 12.244s-8.48-.675-12.58 2.139z"
        fill="#931400"
      />
      <path
        d="M20.548 15.144l-.453 1.996c2.178-.874 5.061-.991 6.61-.979l.67-1.78s-3.956-.268-6.827.763z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M15.633 5.175c.898.871 1.63 2.027 1.972 3.558.203-.306.385-.655.529-1.074.966-2.814 1.964-3.37 3.302-3.25 0 0-3.336-.957-5.803.766z"
        fill="#931400"
      />
      <path
        d="M16.504 12.452C18.545 4.404 10.581 4 10.581 4c1.305.32 2.068 1.17 2.066 4.145 0 2.974 2.457 3.883 2.457 3.883s.613.352 1.4.424z"
        fill="#23D58B"
      />
      <path
        d="M17.42 14.383s-.454.6-1.421.6c-.907 0-1.357-.521-1.41-.586.067.982.5 7.517.453 10.996.823 1.388.84 2.613.837 2.8.008-.19.087-1.436 1.005-2.843.003-3.702.5-10.295.553-10.977l-.014.01h-.003z"
        fill="#1F2937"
      />
    </g>
    <path
      d="M38 21.79V5.724h10.673v2.588h-7.74v4.118h7.31v2.588h-7.31v4.183h7.74v2.587H38zM49.53 21.79l4.097-5.887-4.119-5.844h3.321l3.213 4.744h-1.488l3.213-4.744h3.299l-4.097 5.844 4.075 5.886h-3.299l-3.17-4.722h1.445l-3.17 4.723h-3.32zM65.957 22.048c-.819 0-1.53-.136-2.134-.41-.604-.273-1.071-.66-1.402-1.164-.33-.517-.496-1.114-.496-1.79 0-.646.144-1.221.431-1.725.288-.517.734-.948 1.337-1.293.604-.345 1.366-.59 2.286-.733l3.838-.626v2.157l-3.299.56c-.56.1-.977.28-1.25.54-.274.258-.41.596-.41 1.013 0 .402.15.726.453.97.316.23.704.345 1.164.345.59 0 1.107-.122 1.553-.366.46-.26.812-.611 1.056-1.057.259-.446.388-.934.388-1.466v-3.02c0-.502-.201-.92-.604-1.25-.388-.345-.905-.517-1.552-.517a2.76 2.76 0 00-1.617.496 2.77 2.77 0 00-1.014 1.272l-2.307-1.121c.23-.618.59-1.15 1.078-1.596a5.51 5.51 0 011.768-1.078 6.1 6.1 0 012.2-.388c.963 0 1.811.18 2.544.539.733.345 1.301.834 1.703 1.466.417.618.626 1.344.626 2.178v7.806h-2.674v-2.006l.604-.043a4.912 4.912 0 01-1.078 1.272c-.417.33-.892.59-1.423.776a5.71 5.71 0 01-1.769.26zM74.908 21.79V10.06h2.652v2.716l-.302-.452c.216-.848.647-1.481 1.294-1.898.646-.417 1.408-.625 2.285-.625.963 0 1.811.251 2.545.755.733.503 1.207 1.164 1.423 1.983l-.798.065c.36-.934.898-1.632 1.617-2.092.719-.474 1.546-.711 2.48-.711.834 0 1.574.187 2.22.56a3.988 3.988 0 011.553 1.574c.374.662.56 1.43.56 2.308v7.546h-2.824v-6.878c0-.517-.093-.963-.28-1.337a2.061 2.061 0 00-.776-.862c-.331-.216-.734-.324-1.208-.324a2.19 2.19 0 00-1.186.324c-.345.201-.61.489-.798.862-.186.374-.28.82-.28 1.337v6.879H82.26V14.91c0-.517-.093-.963-.28-1.337a2.017 2.017 0 00-.798-.862c-.33-.216-.726-.324-1.186-.324-.445 0-.84.108-1.186.324-.345.201-.61.489-.797.862-.187.374-.28.82-.28 1.337v6.879h-2.825z"
      fill="currentColor"
    />
    <path
      d="M93.75 21.79L99.29 5.724h3.795l5.542 16.065h-3.192l-1.142-3.45h-6.21l-1.165 3.45h-3.17zm5.174-6.038h4.529l-2.674-8h.819l-2.674 8zM110.178 21.79V5.466h2.825V21.79h-2.825zM115.611 21.79V5.466h2.825V21.79h-2.825zM122.467 26.533c-.316 0-.625-.029-.927-.086a2.498 2.498 0 01-.82-.259v-2.35c.187.043.41.086.669.13.273.043.524.064.754.064.647 0 1.115-.15 1.402-.453.302-.287.568-.675.798-1.164l.776-1.811-.043 2.372-5.11-12.916h3.04l3.579 9.53h-1.078l3.558-9.53h3.062l-5.11 12.915c-.302.748-.669 1.388-1.1 1.92a4.317 4.317 0 01-1.509 1.207c-.561.288-1.208.431-1.941.431z"
      fill="#680E00"
    />
    <defs>
      <clipPath id="clip0_6814_8987">
        <path fill="#fff" transform="translate(2 4)" d="M0 0H28V24.2167H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const footerLogo = (
  <svg
    width={133}
    height={32}
    viewBox="0 0 133 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_569_12039)">
      <path
        d="M16 19.126c-.783 0-1.15-.486-1.15-.486-1.952-1.697-7.743-1.455-7.743-1.455L4.69 10.1s6.851.665 10.16 2.938c0 0 .367.486 1.15.486.782 0 1.148-.486 1.148-.486 3.31-2.273 10.16-2.938 10.16-2.938l-2.416 7.085s-5.789-.241-7.744 1.455c0 0-.366.486-1.149.486z"
        fill="#F5ECEB"
      />
      <path
        d="M16 20.444c-.85 0-1.247-.526-1.247-.526-2.12-1.843-8.404-1.58-8.404-1.58l-2.625-7.653s7.437.182 11.029 2.652c0 0 .397.526 1.246.526.85 0 1.247-.526 1.247-.526 3.592-2.467 11.03-2.652 11.03-2.652l-2.626 7.653s-6.284-.263-8.404 1.58c0 0-.397.526-1.246.526z"
        fill="#FFC8C0"
      />
      <path
        d="M15.999 22.897c-.967 0-1.422-.6-1.422-.6-2.419-2.102-9.586-1.803-9.586-1.803L2 12.244v-.525s8.48-.675 12.58 2.14c0 0 .454.6 1.421.6.967 0 1.422-.6 1.422-.6 4.096-2.815 12.58-2.14 12.58-2.14v.524l-2.994 8.251s-7.165-.301-9.584 1.802c0 0-.455.6-1.421.6h-.005z"
        fill="#FFA395"
      />
      <path
        d="M17.42 14.382s-.454.6-1.421.6c-.967 0-1.422-.6-1.422-.6C10.481 11.568 2 12.242 2 12.242l2.994 8.778s.04 0 .107-.005l-.01.005c10.712.472 10.795 6.73 10.788 7.17.014-.44.417-6.7 11.127-7.17L30 12.243s-8.48-.675-12.58 2.14z"
        fill="#931400"
      />
      <path
        d="M20.548 15.142l-.452 1.996c2.177-.873 5.06-.99 6.61-.979l.67-1.78s-3.957-.268-6.828.763z"
        fill="#fff"
        opacity={0.5}
      />
      <path
        d="M15.633 5.175c.897.871 1.63 2.027 1.972 3.559.203-.307.385-.656.529-1.075.966-2.814 1.964-3.369 3.302-3.25 0 0-3.336-.956-5.803.766z"
        fill="#931400"
      />
      <path
        d="M16.504 12.452C18.544 4.404 10.58 4 10.58 4c1.304.32 2.068 1.17 2.065 4.145 0 2.974 2.458 3.883 2.458 3.883s.612.352 1.4.424z"
        fill="#23D58B"
      />
      <path
        d="M17.42 14.383s-.454.6-1.42.6c-.908 0-1.357-.521-1.41-.586.067.981.5 7.516.452 10.996.823 1.387.84 2.613.838 2.8.007-.19.086-1.436 1.005-2.844.002-3.701.5-10.294.552-10.976l-.014.01h-.002z"
        fill="#1F2937"
      />
    </g>
    <path
      d="M38 21.79V5.726h10.673v2.587h-7.74v4.118h7.31v2.588h-7.31v4.183h7.74v2.588H38zM49.53 21.79l4.097-5.887-4.119-5.843h3.321l3.213 4.743h-1.488l3.213-4.743h3.299l-4.097 5.843 4.075 5.887h-3.299l-3.17-4.723h1.445l-3.17 4.723h-3.32zM65.957 22.048c-.819 0-1.53-.136-2.134-.41-.604-.273-1.071-.66-1.402-1.164-.33-.517-.496-1.114-.496-1.79 0-.646.144-1.221.431-1.724.288-.518.734-.95 1.337-1.294.604-.345 1.366-.59 2.286-.733l3.838-.626v2.157l-3.299.56c-.56.1-.977.28-1.25.54-.274.258-.41.596-.41 1.013 0 .402.15.726.453.97.316.23.704.345 1.164.345.59 0 1.107-.122 1.553-.366.46-.26.812-.611 1.056-1.057.259-.446.388-.934.388-1.466v-3.019c0-.503-.201-.92-.604-1.25-.388-.346-.905-.518-1.552-.518a2.76 2.76 0 00-1.617.496 2.77 2.77 0 00-1.014 1.272l-2.307-1.121c.23-.618.59-1.15 1.078-1.596a5.51 5.51 0 011.768-1.078 6.099 6.099 0 012.2-.388c.963 0 1.811.18 2.544.539.733.345 1.301.834 1.703 1.466.417.618.626 1.344.626 2.178v7.806h-2.674v-2.006l.604-.043a4.912 4.912 0 01-1.078 1.272c-.417.331-.892.59-1.423.777a5.71 5.71 0 01-1.769.258zM74.908 21.79V10.06h2.652v2.716l-.302-.452c.216-.848.647-1.481 1.294-1.898.646-.417 1.408-.625 2.285-.625.963 0 1.811.251 2.545.755.733.503 1.207 1.164 1.423 1.983l-.798.065c.36-.934.898-1.632 1.617-2.092.719-.474 1.546-.711 2.48-.711.834 0 1.574.187 2.22.56a3.989 3.989 0 011.553 1.574c.374.662.56 1.43.56 2.308v7.547h-2.824V14.91c0-.517-.093-.963-.28-1.337a2.06 2.06 0 00-.776-.862c-.331-.216-.734-.324-1.208-.324a2.19 2.19 0 00-1.186.324c-.345.201-.61.489-.798.862-.186.374-.28.82-.28 1.337v6.879H82.26V14.91c0-.517-.093-.963-.28-1.337a2.016 2.016 0 00-.798-.862c-.33-.216-.726-.324-1.186-.324-.445 0-.84.108-1.186.324-.345.201-.61.489-.797.862-.187.374-.28.82-.28 1.337v6.879h-2.825z"
      fill="#111827"
    />
    <path
      d="M93.75 21.79L99.29 5.726h3.795l5.542 16.064h-3.192l-1.142-3.45h-6.21l-1.165 3.45h-3.17zm5.174-6.038h4.529l-2.674-8h.819l-2.674 8zM110.178 21.79V5.467h2.825V21.79h-2.825zM115.611 21.79V5.467h2.825V21.79h-2.825zM122.467 26.533c-.316 0-.625-.028-.927-.086a2.498 2.498 0 01-.82-.259v-2.35c.187.043.41.086.669.13.273.043.524.064.754.064.647 0 1.115-.15 1.402-.453.302-.287.568-.675.798-1.164l.776-1.811-.043 2.372-5.11-12.916h3.04l3.579 9.53h-1.078l3.558-9.53h3.062l-5.11 12.915c-.302.748-.669 1.388-1.1 1.92a4.317 4.317 0 01-1.509 1.207c-.561.288-1.208.431-1.941.431z"
      fill="#680E00"
    />
    <defs>
      <clipPath id="clip0_569_12039">
        <path fill="#fff" transform="translate(2 4)" d="M0 0H28V24.2167H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const facebookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M17.334 9a8.333 8.333 0 10-9.636 8.232V11.41H5.582V9h2.116V7.164c0-2.088 1.244-3.242 3.148-3.242.912 0 1.865.163 1.865.163v2.05h-1.05c-1.036 0-1.359.643-1.359 1.302V9h2.312l-.37 2.41h-1.942v5.822A8.335 8.335 0 0017.334 9z"
      fill="#1877F2"
    />
    <path
      d="M12.244 11.41l.37-2.41h-2.312V7.438c0-.659.323-1.3 1.358-1.3h1.05V4.084s-.953-.162-1.865-.162c-1.903 0-3.147 1.153-3.147 3.242V9H5.582v2.409h2.116v5.823a8.392 8.392 0 002.604 0v-5.824h1.942z"
      fill="#fff"
    />
  </svg>
);

export const youtubeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={14}
    viewBox="0 0 20 14"
    fill="none"
  >
    <path
      d="M18.783 2.773a2.3 2.3 0 00-1.62-1.627C15.732.76 10 .76 10 .76s-5.733 0-7.163.385a2.3 2.3 0 00-1.62 1.627C.832 4.208.832 7.203.832 7.203s0 2.994.383 4.43a2.3 2.3 0 001.621 1.627c1.43.385 7.163.385 7.163.385s5.733 0 7.162-.385a2.3 2.3 0 001.621-1.627c.383-1.436.383-4.43.383-4.43s0-2.995-.383-4.43z"
      fill="#ED1D24"
    />
    <path d="M8.333 9.799l4.646-2.81L8.333 4.18V9.8z" fill="#fff" />
  </svg>
);

export const instagramIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M14.437 4.538a1 1 0 10-2.002 0 1 1 0 002.002 0z"
      fill="url(#paint0_linear_569_12067)"
    />
    <path
      d="M13.584 4.416h.008M4.834.666h8.333a4.167 4.167 0 014.167 4.167v8.333a4.167 4.167 0 01-4.167 4.167H4.834a4.167 4.167 0 01-4.167-4.167V4.833A4.167 4.167 0 014.834.666zm7.5 7.808a3.334 3.334 0 11-6.596.978 3.334 3.334 0 016.596-.978z"
      stroke="url(#paint1_linear_569_12067)"
      strokeWidth={1.25}
    />
    <defs>
      <linearGradient
        id="paint0_linear_569_12067"
        x1={0.804695}
        y1={17.1474}
        x2={15.9329}
        y2={2.01922}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD521" />
        <stop offset={0.05} stopColor="#FFD521" />
        <stop offset={0.501119} stopColor="#F50000" />
        <stop offset={0.95} stopColor="#B900B4" />
        <stop offset={0.950079} stopColor="#B900B4" />
        <stop offset={1} stopColor="#B900B4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_569_12067"
        x1={0.817323}
        y1={17.1811}
        x2={15.9579}
        y2={2.04052}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD521" />
        <stop offset={0.05} stopColor="#FFD521" />
        <stop offset={0.501119} stopColor="#F50000" />
        <stop offset={0.95} stopColor="#B900B4" />
        <stop offset={0.950079} stopColor="#B900B4" />
        <stop offset={1} stopColor="#B900B4" />
      </linearGradient>
    </defs>
  </svg>
);

export const scrollDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M10 4.166v11.667m0 0l5.834-5.834M10 15.833L4.167 9.999"
      stroke="#344054"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const downloadICon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    fill="none"
  >
    <path
      d="M7 10.5V2.335h14v8.167M7 21H4.666a2.333 2.333 0 01-2.333-2.334v-5.833a2.333 2.333 0 012.333-2.333h18.667a2.333 2.333 0 012.333 2.333v5.833a2.333 2.333 0 01-2.333 2.334H21M7 16.334h14v9.333H7v-9.333z"
      stroke="currentColor"
      strokeWidth={2.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const coursesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={28}
    viewBox="0 0 29 28"
    fill="none"
  >
    <path
      d="M14.5 8.167A4.667 4.667 0 009.833 3.5h-7V21H11a3.5 3.5 0 013.5 3.5m0-16.333V24.5m0-16.333A4.667 4.667 0 0119.166 3.5h7V21H18a3.5 3.5 0 00-3.5 3.5"
      stroke="currentColor"
      strokeWidth={2.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const galaxyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={121}
    height={109}
    viewBox="0 0 121 109"
    fill="none"
  >
    <path
      d="M22.727 10.993l-2.64 1.389.504-2.942-2.138-2.083 2.953-.429 1.322-2.676 1.32 2.676 2.954.43-2.138 2.082.505 2.942-2.642-1.389zM46.688 26.399a3.565 3.565 0 110-7.131 3.565 3.565 0 010 7.13zM18.448 44.812a5.705 5.705 0 110-11.41 5.705 5.705 0 010 11.41zM50.967 57.482a2.14 2.14 0 110-4.279 2.14 2.14 0 010 4.279zM118.57 58.337a2.139 2.139 0 110-4.277 2.139 2.139 0 010 4.277zM105.734 12.267a1.426 1.426 0 110-2.852 1.426 1.426 0 010 2.852zM3.9 2.852A1.426 1.426 0 113.9 0a1.426 1.426 0 010 2.852zM93.696 104.314v-2.853a.57.57 0 00-1.141 0v2.853h-2.853a.57.57 0 100 1.141h2.853v2.852a.57.57 0 001.14 0v-2.852h2.853a.571.571 0 000-1.141h-2.852zM96.064 52.505v-2.14a.428.428 0 00-.856 0v2.14h-2.14a.428.428 0 000 .855h2.14v2.14a.427.427 0 10.856 0v-2.14h2.139a.428.428 0 000-.855h-2.14zM101.924 75.83l1.26-1.26a.348.348 0 00.109-.253.344.344 0 00-.104-.255.359.359 0 00-.509.004l-1.261 1.26-1.26-1.26a.353.353 0 00-.253-.109.358.358 0 00-.331.497.357.357 0 00.08.116l1.26 1.26-1.26 1.261a.356.356 0 10.504.504l1.26-1.26 1.261 1.26a.353.353 0 00.392.083.366.366 0 00.195-.195.345.345 0 00.026-.138.347.347 0 00-.109-.253l-1.26-1.261zM34.45 82.456v-2.14a.428.428 0 00-.855 0v2.14h-2.14a.428.428 0 100 .856h2.14v2.139a.428.428 0 10.855 0v-2.14h2.14a.428.428 0 000-.855h-2.14zM4.65 68.108l2.017-2.018a.57.57 0 10-.807-.806L3.843 67.3l-2.016-2.016a.572.572 0 10-.807.806l2.017 2.017-2.017 2.017a.57.57 0 10.807.807l2.016-2.017 2.017 2.017a.57.57 0 10.807-.807L4.65 68.107z"
      fill="#FF593F"
    />
  </svg>
);

export const arrowDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const arrowUpIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M18 15l-6-6-6 6"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const eyeCloseIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_648_12073)">
      <path
        d="M8.25 3.534a7.6 7.6 0 011.75-.2c5.834 0 9.167 6.667 9.167 6.667a15.416 15.416 0 01-1.8 2.658m-5.6-.892a2.5 2.5 0 11-3.534-3.533m-7.4-7.4l18.334 18.333m-4.217-4.216A8.392 8.392 0 0110 16.667c-5.833 0-9.167-6.666-9.167-6.666A15.375 15.375 0 015.05 5.05l9.9 9.9z"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const eyeOpenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g
      clipPath="url(#clip0_714_534)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M.833 10S4.167 3.335 10 3.335c5.834 0 9.167 6.667 9.167 6.667S15.833 16.667 10 16.667.833 10.001.833 10.001z" />
      <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
    </g>
  </svg>
);

export const bookOpenIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
  >
    <path
      d="M13 7.792a4.167 4.167 0 00-4.166-4.167h-6.25V19.25h7.291A3.125 3.125 0 0113 22.375m0-14.583v14.583m0-14.583a4.167 4.167 0 014.167-4.167h6.25V19.25h-7.292A3.125 3.125 0 0013 22.375"
      stroke="currentColor"
      strokeWidth={2.34375}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const googleIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.784 10.302c0-.68-.061-1.333-.175-1.96H9.583v3.707h5.158a4.409 4.409 0 01-1.912 2.892v2.405h3.097c1.812-1.669 2.857-4.125 2.857-7.044z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.583 19.667c2.588 0 4.757-.858 6.342-2.322l-3.097-2.404c-.858.574-1.955.914-3.245.914-2.496 0-4.609-1.686-5.362-3.95H1.019v2.482a9.58 9.58 0 008.564 5.28z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.221 11.904a5.76 5.76 0 01-.3-1.82c0-.633.108-1.247.3-1.822V5.78H1.019A9.58 9.58 0 000 10.083c0 1.546.37 3.01 1.02 4.304l3.201-2.483z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.583 4.312c1.407 0 2.67.483 3.663 1.433l2.75-2.749C14.335 1.45 12.165.5 9.582.5A9.58 9.58 0 001.02 5.78l3.202 2.482c.753-2.265 2.866-3.95 5.362-3.95z"
      fill="#EA4335"
    />
  </svg>
);

export const homeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.5 18.333V9.999h5v8.334M2.5 7.499L10 1.666l7.5 5.833v9.167a1.666 1.666 0 01-1.667 1.667H4.167A1.667 1.667 0 012.5 16.666V7.499z"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const rightArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6 12l4-4-4-4"
      stroke="currentColor"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const leftArrowIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.667 8H3.333m0 0L8 12.668M3.333 8.001L8 3.334"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const searchIcon = (
  <svg
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.5 17.5l-3.625-3.625m1.958-4.708a6.667 6.667 0 11-13.333 0 6.667 6.667 0 0113.333 0z"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const folderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M14.667 12.667A1.334 1.334 0 0113.333 14H2.667a1.333 1.333 0 01-1.334-1.333V3.333A1.333 1.333 0 012.667 2H6l1.333 2h6a1.333 1.333 0 011.334 1.333v7.334z"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const probabilityIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M6.667 2H2v4.667h4.667V2zM14 2H9.333v4.667H14V2zM14 9.333H9.333V14H14V9.333zM6.667 9.333H2V14h4.667V9.333z"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const geometryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.18 4.64L8 8.005l5.82-3.367M8 14.72V8m6 2.667V5.333a1.333 1.333 0 00-.667-1.154L8.667 1.513a1.333 1.333 0 00-1.334 0L2.667 4.179A1.333 1.333 0 002 5.333v5.333a1.333 1.333 0 00.667 1.153l4.666 2.667a1.334 1.334 0 001.334 0l4.666-2.667A1.333 1.333 0 0014 10.666z"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const functionsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M15.333 4L9 10.333 5.667 7l-5 5m14.666-8h-4m4 0v4"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const trigonometryIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_714_6127)">
      <path
        d="M8 1.334v2.667m0 8v2.666M3.287 3.287l1.886 1.887m5.654 5.653l1.886 1.887M1.333 8.001H4m8 0h2.667m-11.38 4.713l1.886-1.887m5.654-5.653l1.886-1.887"
        stroke="currentColor"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const integrationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_714_6179)">
      <path
        d="M14.667 8A6.667 6.667 0 018 14.668m6.667-6.666A6.667 6.667 0 008 1.334m6.667 6.667H1.333M8 14.667a6.667 6.667 0 01-6.667-6.666M8 14.667a10.2 10.2 0 002.667-6.666A10.2 10.2 0 008 1.334m0 13.333a10.2 10.2 0 01-2.667-6.666A10.2 10.2 0 018 1.334M1.333 8.001A6.667 6.667 0 018 1.334"
        stroke="currentColor"
        strokeWidth={1.33}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const helpIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 19h.01M8.217 7.697A4.002 4.002 0 0116 9a4.001 4.001 0 01-2.442 3.685c-.74.314-1.111.47-1.24.592a.75.75 0 00-.257.386C12 13.83 12 14.087 12 14.6V16"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const tagIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M5 5h.007m9.053 4.273l-4.78 4.78a1.333 1.333 0 01-1.887 0l-5.726-5.72V1.666h6.666l5.727 5.727a1.333 1.333 0 010 1.88z"
      stroke="currentColor"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const checkCircleIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_812_583)">
      <path
        d="M14.667 7.387v.614a6.666 6.666 0 11-3.954-6.094m3.954.76L8 9.341l-2-2"
        stroke="currentColor"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const minusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.333 8h9.334"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const flagIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2.667 10s.666-.666 2.666-.666 3.334 1.333 5.334 1.333c2 0 2.666-.666 2.666-.666V2s-.666.666-2.666.666-3.334-1.333-5.334-1.333c-2 0-2.666.667-2.666.667v8zm0 0v4.667"
      stroke="currentColor"
      strokeWidth={1.67}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const uploadIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_812_3344)">
      <path
        d="M10.667 10.667L8 8m0 0l-2.667 2.667M8 8v6m5.593-1.74A3.333 3.333 0 0012 6h-.84A5.333 5.333 0 102 10.867"
        stroke="currentColor"
        strokeWidth={1.33333}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const refreshIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_858_9414)">
      <path
        d="M.667 2.667v4m0 0h4m-4 0L3.76 3.76A6 6 0 0113.66 6m1.673 7.334v-4m0 0h-4m4 0L12.24 12.24A6 6 0 012.34 10"
        stroke="currentColor"
        strokeWidth={1.67}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const alertIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 8v4m0 4h.01M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const alertTriangleIcons = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 8v4m0 4h.01M10.29 2.86L1.82 17a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 2.86a2 2 0 00-3.42 0z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const checkTickIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M16.667 5L7.5 14.167 3.333 10"
      stroke="currentColor"
      strokeWidth={1.66667}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const bookmarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M19.5 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const fillBookmarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="currentColor"
  >
    <path d="M19.5 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2v16z" />
  </svg>
);

export const fileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
  >
    <path
      d="M14.5 2h-8a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8m-6-6l6 6m-6-6v6h6m-4 5h-8m8 4h-8m2-8h-2"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const noFolderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1 5a3 3 0 01.282-1.269c.083.14.184.27.304.39L3 5.535V19a1 1 0 001 1h13.465l2 2H4a3 3 0 01-3-3V5zm4.121-3l2 2h1.344l1.703 2.555A1 1 0 0011 7h9a1 1 0 011 1v9.879l1.799 1.799c.034.034.066.068.097.104.069-.253.104-.516.104-.782V8a3 3 0 00-3-3h-8.465L9.832 2.445A1 1 0 009 2H5.121zM2.586 3.707A1 1 0 014 2.293l18.385 18.385a1 1 0 01-1.414 1.414L2.586 3.707z"
      fill="currentColor"
    />
  </svg>
);

export const fillFolderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      d="M36.666 31.667A3.333 3.333 0 0133.333 35H6.666a3.333 3.333 0 01-3.333-3.333V8.333A3.333 3.333 0 016.666 5H15l3.333 5h15a3.333 3.333 0 013.333 3.333v18.334z"
      fill="currentColor"
    />
  </svg>
);

export const removeBookmarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    viewBox="0 0 17 16"
    fill="none"
  >
    <g clipPath="url(#clip0_973_14492)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.999 14V5.935l1.67 1.357v5.083l3.33-2.379 5.71 4.637a.837.837 0 01-1.027.044L8.5 11.692 4.32 14.678A.835.835 0 012.999 14zm.939-12.454l1.586 1.288h6.31a.498.498 0 01.498.498v5.031l1.67 1.356V3.332a2.169 2.169 0 00-2.168-2.168H5.167c-.442 0-.87.135-1.23.382zM2.264 4.772a1 1 0 011.261-1.553l20.182 16.392a1 1 0 01-1.261 1.553L2.264 4.772z"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const saveIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M11.333 14V8.667H4.667V14m0-12v3.333H10M12.667 14H3.333A1.334 1.334 0 012 12.667V3.333A1.333 1.333 0 013.333 2h7.334L14 5.333v7.334A1.334 1.334 0 0112.667 14z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const printIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_973_13392)">
      <path
        d="M4 6V1.335h8v4.667m-8 6H2.667a1.333 1.333 0 01-1.333-1.334V7.334a1.333 1.333 0 011.333-1.333h10.666a1.333 1.333 0 011.334 1.333v3.333a1.333 1.333 0 01-1.333 1.334H12M4 9.334h8v5.333H4V9.334z"
        stroke="currentColor"
        strokeWidth={1.67}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const deleteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M2 4h1.333m0 0H14M3.333 4v9.334a1.333 1.333 0 001.334 1.333h6.666a1.333 1.333 0 001.334-1.333V4.001H3.333zm2 0V2.668a1.333 1.333 0 011.334-1.333h2.666a1.333 1.333 0 011.334 1.333v1.334"
      stroke="currentColor"
      strokeWidth={1.33333}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const editIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clipPath="url(#clip0_7069_1101)">
      <path
        d="M9.167 3.333H3.334A1.667 1.667 0 001.667 5v11.667a1.667 1.667 0 001.667 1.666H15a1.667 1.667 0 001.667-1.666v-5.834m-1.25-8.75a1.768 1.768 0 012.5 2.5L10 12.5l-3.333.833L7.5 10l7.917-7.917z"
        stroke="currentColor"
        strokeWidth={1.6625}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const settingIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <g
      clipPath="url(#clip0_7069_1105)"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10 12.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
      <path d="M16.166 12.5a1.375 1.375 0 00.275 1.517l.05.05a1.667 1.667 0 11-2.358 2.358l-.05-.05a1.376 1.376 0 00-1.517-.275 1.376 1.376 0 00-.833 1.258v.142a1.667 1.667 0 11-3.333 0v-.075a1.375 1.375 0 00-.9-1.258 1.375 1.375 0 00-1.517.275l-.05.05a1.667 1.667 0 11-2.358-2.359l.05-.05a1.375 1.375 0 00.275-1.516 1.374 1.374 0 00-1.259-.834H2.5a1.667 1.667 0 110-3.333h.075a1.375 1.375 0 001.258-.9 1.375 1.375 0 00-.275-1.517l-.05-.05a1.667 1.667 0 112.358-2.358l.05.05a1.375 1.375 0 001.517.275H7.5a1.375 1.375 0 00.833-1.258V2.5a1.667 1.667 0 113.333 0v.075a1.376 1.376 0 00.834 1.258 1.375 1.375 0 001.516-.275l.05-.05a1.666 1.666 0 012.72 1.818 1.666 1.666 0 01-.361.54l-.05.05a1.375 1.375 0 00-.275 1.517V7.5a1.375 1.375 0 001.258.833h.142a1.667 1.667 0 010 3.334h-.075a1.375 1.375 0 00-1.259.833z" />
    </g>
  </svg>
);

export const logoutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
  >
    <path
      d="M7.5 17.5H4.167A1.667 1.667 0 012.5 15.833V4.167A1.667 1.667 0 014.167 2.5H7.5m5.833 11.667L17.5 10m0 0l-4.167-4.167M17.5 10h-10"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ellipseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M12 13a1 1 0 100-2 1 1 0 000 2zM12 6a1 1 0 100-2 1 1 0 000 2zM12 20a1 1 0 100-2 1 1 0 000 2z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const floderMinusIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={20}
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M8 11.667h5m5.833 4.166a1.666 1.666 0 01-1.666 1.667H3.832a1.667 1.667 0 01-1.667-1.667V4.167A1.667 1.667 0 013.833 2.5H8L9.666 5h7.5a1.667 1.667 0 011.667 1.667v9.166z"
      stroke="currentColor"
      strokeWidth={1.33}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const longLeftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.667 8H3.333m0 0L8 12.668M3.333 8.001L8 3.334"
      stroke="currentColor"
      strokeWidth={1.67}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const longRightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M3.333 8h9.334m0 0L8 3.335m4.667 4.667L8 12.667"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const dashboard = (
  <svg
    width={15}
    height={21}
    viewBox="0 0 15 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.961 19.54V1.56M1.968 19.54V5.555M13.953 19.54v-6.992"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const errorIcon = (
  <svg
    width={161}
    height={135}
    viewBox="0 0 161 135"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 118V56.5c50.4-18.4 110-7.667 133.5 0V118C95.1 144.8 36.667 129.167 14 118z"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path
      d="M27 112.533v-47.66c40.395-14.259 88.165-5.941 107 0v47.66c-41.999 20.768-88.833 8.653-107 0zM147.5 104.5c9-6.333 21.6-21.9 0-33.5M13.427 104.5c-9-6.333-21.6-21.9 0-33.5"
      stroke="currentColor"
      strokeWidth={3}
    />
    <circle cx={58} cy={84} r={10} fill="currentColor" />
    <circle cx={80} cy={9} r={9} fill="currentColor" />
    <circle cx={100} cy={84} r={10} fill="currentColor" />
    <path
      d="M59.135 110.687c5.28-5.521 20.765-13.533 40.476-1.413M58.011 46.646c6.384-10.554 24.621-25.238 46.498.463"
      stroke="currentColor"
      strokeWidth={3}
    />
    <path fill="currentColor" d="M77 16H84V32H77z" />
  </svg>
);

export const users = (
  <svg
    width={25}
    height={21}
    viewBox="0 0 24 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.954 19.383V17.39a4 4 0 0 0-4-4h-7.98a4 4 0 0 0-4 4v2M9.5 8.626a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7zM23.95 19.383V17.39a4 4 0 0 0-3-3.865M16.955 1.534a4 4 0 0 1 0 7.74"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const rightArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const leftArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="5.241"
    height="11.265"
    viewBox="0 0 5.241 11.265"
  >
    <path
      id="Path_41"
      data-name="Path 41"
      d="M7212.063-9151.6l-3.56,4.65,3.56,4.651"
      transform="translate(-7207.804 9152.58)"
      fill="none"
      stroke="#acacb0"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const downArrow = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="4.531"
    height="9.409"
    viewBox="0 0 4.531 9.409"
  >
    <path
      id="Path_40564"
      data-name="Path 40564"
      d="M2.85,0,0,3.723,2.85,7.448"
      transform="translate(3.832 8.429) rotate(180)"
      fill="none"
      stroke="#A3A6AC"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const bellIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.2"
    height="15.62"
    viewBox="0 0 14.2 15.62"
  >
    {" "}
    <g id="bell" transform="translate(0.7 0.7)">
      {" "}
      <path
        id="Path_21414"
        data-name="Path 21414"
        d="M13.667,6.267a4.267,4.267,0,1,0-8.533,0c0,4.978-2.133,6.4-2.133,6.4H15.8s-2.133-1.422-2.133-6.4"
        transform="translate(-3 -2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
      <path
        id="Path_21415"
        data-name="Path 21415"
        d="M12.73,21a1.422,1.422,0,0,1-2.46,0"
        transform="translate(-5.1 -7.489)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />{" "}
    </g>{" "}
  </svg>
);

export const menuHamburgerIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="23.837"
    height="16.558"
    viewBox="0 0 23.837 16.558"
  >
    <g data-name="Icon feather-menu" transform="translate(-3.5 -8)">
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(0 -1.721)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40586"
        data-name="Path 40586"
        d="M4.5,9H26.337"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40587"
        data-name="Path 40587"
        d="M4.5,27H26.337"
        transform="translate(0 -3.442)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const menuCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18.27"
    height="18.27"
    viewBox="0 0 18.27 18.27"
  >
    <g
      id="Icon_feather-menu"
      data-name="Icon feather-menu"
      transform="translate(-3.086 -7.144)"
    >
      <path
        id="Path_40585"
        data-name="Path 40585"
        d="M4.5,18H26.337"
        transform="translate(14.046 -7.351) rotate(45)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
      <path
        id="Path_40588"
        data-name="Path 40588"
        d="M0,0H21.837"
        transform="translate(19.942 8.558) rotate(135)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </g>
  </svg>
);

export const logOutsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.6}
    height={17.158}
    viewBox="0 0 15.6 17.158"
  >
    <g data-name="Group 27693">
      <g data-name="Group 27692">
        <g
          data-name="power (1)"
          transform="translate(-17.201 -901.932) translate(15.006 900.732)"
          fill="none"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.6}
        >
          <path
            data-name="Path 49129"
            d="M14.946 6.64a6.013 6.013 0 010 9.045 7.476 7.476 0 01-9.9 0 6.013 6.013 0 010-9.045"
          />
          <path
            data-name="Line 8641"
            transform="translate(9.999 2)"
            d="M0 0L0 10"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const moonIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="currentColor"
    className="bi bi-moon"
    viewBox="0 0 16 16"
  >
    <path d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278zM4.858 1.311A7.269 7.269 0 0 0 1.025 7.71c0 4.02 3.279 7.276 7.319 7.276a7.316 7.316 0 0 0 5.205-2.162c-.337.042-.68.063-1.029.063-4.61 0-8.343-3.714-8.343-8.29 0-1.167.242-2.278.681-3.286z" />
  </svg>
);

export const profileIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={18.4}
    viewBox="0 0 18.4 18.4"
  >
    <g
      data-name="Group 20504"
      transform="translate(-105.8 -129.8)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <g data-name="user (1)" transform="translate(109.9 134.051)">
        <path
          data-name="Path 1"
          d="M10.2 11.471V9.903a2.89 2.89 0 00-2.552-3.138h-5.1A2.89 2.89 0 000 9.903v1.569"
        />
        <circle
          data-name="Ellipse 1"
          cx={3.233}
          cy={3.233}
          r={3.233}
          transform="translate(1.8)"
        />
      </g>
      <circle cx={8.5} cy={8.5} r={8.5} transform="translate(106.5 130.5)" />
    </g>
  </svg>
);

export const defaultUserIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 1280 1280"
    xmlSpace="preserve"
  >
    <path
      fill="#E6483F"
      opacity={1}
      d="M618 1281H1V1h1280v1280H618M350.966 998.052s-.026.061.099.522c.175.297.435.465.862.491 0 0 .013.085.269.616.643.416 1.285.832 2.464 1.703.793.854 1.585 1.708 2.348 2.742 0 0 .307 0 .806.19.136.116.271.232.57.856.26.236.521.471.66.747 0 0 .105-.075.219.576 2.085 1.55 4.17 3.1 6.648 4.836 0 0 .296.318.666.85.792.28 1.584.56 2.915 1.202 1.515.836 3.03 1.671 4.86 2.951.327.144.653.289 1.331.534 0 0 .295.217.563.828 3.653 1.64 7.306 3.278 11.07 4.886 0 0 .037.11.012.387l.322.23s.362-.137 1.021-.032c.44.068.88.135 1.848.583 3.25 1.287 6.5 2.575 9.717 3.972 0 0 .077-.086.47.492 2.424.457 4.848.915 8.083 1.245 1.36-.015 2.72-.03 4.03.47 1.72.76 3.44 1.519 5.838 2.219.452-.017.905-.033 1.862.323 1.525-.071 3.05-.142 5.38-.598 3.893.684 7.705-.464 11.734 2.543 3.006 2.243 8.5 1.498 12.886 1.5 124.479.063 248.958.069 373.437-.012 4.996-.003 9.985-1.005 14.989-1.413 3.172-.26 6.302.78 9.24-2.176 1.35-1.358 4.892-.6 7.444-.684 2.91-.096 5.93.425 8.713-.186 5.208-1.145 10.216-3.878 15.419-4.215 9.812-.635 15.517-10.112 25.116-10.663.13-.008.354-.204.36-.32.16-3.535 3.342-2.89 5.314-3.618 3.204-1.183 5.204-2.635 2.692-6.74 7.742 1.553 11.034-4.334 15.913-7.35 5.3-3.274 4.87-11.299 11.694-13.204.878-.246 1.195-2.885 1.554-4.465.25-1.096-.282-2.53.242-3.375 2.127-3.434 4.526-6.7 7.363-10.805 2.744-.068 4.736-2.236 5.546-6.259.867-4.297 1.649-8.923 3.843-12.581 5.488-9.15 5.94-19.268 6.606-29.298.728-10.98 1.017-22.02.81-33.022-.29-15.267-.654-30.574-2.07-45.763-1.008-10.82-3.907-21.456-5.75-32.21-.864-5.036.297-11.16-2.215-14.977-2.904-4.41 1.73-11.02-4.864-13.516 1.46-4.375-.625-8.039-1.952-12.025-.908-2.726.926-6.526-3.894-7.172-.278-.037-.756-1.959-.419-2.652 2.548-5.229-.166-6.781-5.282-6.828 0-2.116-.298-3.981.051-5.716 1.56-7.757-3.973-13.7-5.166-20.738-.08-.47-.982-.758-1.406-1.219-.884-.961-1.957-1.86-2.504-2.999-2.421-5.047-4.532-10.248-7.104-15.213-.69-1.333-2.658-1.969-3.946-3.038-.784-.651-1.925-1.476-1.99-2.296-.598-7.484-4.459-12.585-10.99-15.961-.604-.313-1.159-1.333-1.19-2.048-.27-6.218-4.81-8.268-8.487-9.658-1.724-2.691-2.55-4.965-4.16-6.284-3.154-2.585-6.72-4.678-10.161-6.902-3.73-2.409-6.255-7.01-11.634-6.443-2.918-6.64-10.326-6.37-15.314-9.87-8.303-5.83-19.335-3.795-27.966-9.09-1.126-.69-2.931-.307-4.424-.362-1.497-.055-3.055.226-4.488-.09-11.22-2.47-22.242-4.399-33.692-.123-4.098 1.53-7.634 2.01-7.164 7.477-3.19.153-6.408-.551-8.682.602-4.387 2.224-8.14 5.658-12.337 8.301-8.016 5.048-16.21 9.814-24.215 14.88-1.924 1.218-3.396 3.152-5.076 4.757-6.48 3.104-15.585 1.526-19.337 10.805-7.27 1.59-14.661 2.15-22.112 4.617-11.55 3.823-24.234 5.103-36.513 5.604-12.827.523-25.8-.632-38.603-2.028-10.082-1.1-20.003-3.675-29.992-5.612-1.3-.253-3.217-.184-3.766-.996-3.17-4.684-8.462-5.352-13.017-7.439-6.426-2.943-13.037-5.595-19.113-9.15-4.015-2.35-9.39-2.258-12.143-7.114-1.278-2.254-3.621-4.119-5.862-5.575-9.121-5.926-18.193-11.982-27.694-17.246-4.167-2.308-9.272-3.743-14.037-4.007-19.92-1.103-39.06 3.318-57.785 9.654-1.968.666-3.44 2.799-5.652 4.686-4.514-1.357-17.131 5.48-18.704 11.198-4.49-.112-9.682-1.02-9.461 6.2-7.028-.214-9.542 3.94-10.014 9.786-6.828.564-8.809 2.563-9.656 8.46-2.552 2.17-4.73 3.499-6.175 5.39-1.546 2.023-2.101 4.8-3.633 6.84-2.063 2.748-5.176 4.79-6.905 7.69-4.559 7.65-8.698 15.557-12.811 23.463-1.026 1.971-1.32 4.323-2.04 6.808-.74.97-2.176 2.196-2.778 3.747-2.866 7.383-5.658 14.802-8.164 22.312-1.476 4.424-2.308 9.059-3.545 13.567-.856 3.12-2.894 6.256-2.682 9.264.558 7.936-2.891 14.675-5.31 22.158 0 0 .074.384.023.941-.073.172-.147.343-.756.915-.134 2.243-.268 4.486-.33 7.453-.179.696-.358 1.392-.902 2.31a74.77 74.77 0 00-.081 2.57c-.131.405-.262.809-.814 1.375-.09.655-.18 1.31-.286 2.612-.132.41-.264.819-.805 1.67.106 1.606.212 3.212.157 4.78 0 0 .158.056-.398.542-.269 3.126-.537 6.251-.85 10.022-.139.406-.276.813-.787 1.429l-.287 2.72c-.046 1.067-.093 2.135-.439 3.879-.335 5.556-.67 11.112-.866 17.42-.035 1.527-.07 3.053-.45 5.392a1300.25 1300.25 0 01-.337 14.42c-.13 7.691-.261 15.382-.748 23.556.246 1.531.491 3.063.95 5.308.01.739.02 1.478-.292 2.765.38 1.536.76 3.071 1.29 4.611 0 0 .046.145.175.759.167 3.01.125 6.052.553 9.025.54 3.754 1.462 7.453 2.496 11.484 0 0 .125.394.115 1.21 1.882 5.488 3.764 10.977 6.228 16.57.194.031.389.063.957.444.48.157.96.313 1.58 1.089-.022.421-.044.842-.445 1.925-1.989 7.171 6.257 10.142 6.812 16.31.006.069 1.791-.023 2.8-.059 0 0 .015.054-.026.611.177.514.354 1.027.62 2.207.022.447.046.894-.128 1.755.454.53.909 1.058 1.429 1.587 0 0-.03.058.082.641.602.46 1.204.92 2.28 1.71.176.34.351.678.583 1.37.13.234.329.345 1.007.543 0 0 .295.355.429.874.25.247.5.495.653.78 0 0 .083-.064.142.57.873.862 1.745 1.724 2.721 2.632 0 0-.019.11.054.746.986.713 1.973 1.426 3.318 2.595.581.508 1.162 1.016 1.904 1.978.17.294.42.484.816.57M677.57 621.995c3.786-1.472 8.748-1.974 11.002-4.709 1.964-2.382 4.12-2.796 6.276-3.666 1.053-.425 2.877 1.32 4.107 1.033 4.171-.972 8.466-1.929 12.288-3.773 8.21-3.96 16.228-8.345 24.13-12.894 1.155-.664 1.242-3.18 2.053-5.497 5.592 1.718 9.414-3.022 13.78-6.455 1.094-.86 1.696-2.34 2.781-3.214 4.678-3.77 10.577-6.61 13.949-11.288 6.486-9 16.88-15.006 20.264-26.338.085-.282.929-.262 1.206-.573 1.906-2.133 3.921-4.2 5.576-6.52 1.652-2.315 3.052-4.836 4.332-7.383 1.734-3.452 4.458-6.987 4.539-10.538.094-4.128.225-6.813 4.676-7.091.553-1.784.988-3.293 1.488-4.782 2.535-7.55 5.269-15.039 7.556-22.662 1.178-3.925 1.268-8.17 2.37-12.126 4.106-14.748 4.28-29.8 3.469-44.875-.418-7.768-1.672-15.503-2.781-23.219-.794-5.518-1.957-10.983-3.005-16.463-.15-.787-.438-2.062-.91-2.19-3.028-.817-2.33-3.023-2.37-5.171-.025-1.377-.651-2.775-1.164-4.104-.738-1.91-1.765-3.715-2.407-5.652-1.571-4.742-2.413-9.822-4.604-14.242-3.748-7.56-7.866-15.02-12.638-21.967-5.164-7.518-11.181-14.46-16.973-21.532-2.742-3.35-5.238-7.214-10.584-6.864-.872.057-1.85-1.523-2.78-2.346l2.64-2.673c-7.26-6-14.08-12.556-21.797-17.788-10.123-6.863-20.693-13.19-31.574-18.765-6.785-3.476-14.701-4.671-21.75-7.723-11.063-4.79-22.39-6.942-34.383-5.864-1.438.13-3.15.055-4.36-.609-5.963-3.277-12.502-3.6-18.925-3.276-8.018.405-15.998 1.663-23.975 2.699-5.415.703-11.37.5-16.042 2.808-5.344 2.64-11.038 2.492-16.299 4.44-5.304 1.965-11.52 2.27-15.002 7.863-.385.619-1.773 1.044-2.578.9-4.445-.796-7.622 1.794-11.011 3.851-2.325 1.412-4.456 3.455-6.972 4.174-5.196 1.487-9.849 2.969-8.494 10.37-3.05 0-6.268-.932-8.031.27-1.66 1.13-1.784 4.512-2.668 7.159-4.071-.495-9.329-2.91-9.383 4.556-6.082.77-9.46 3.966-10.003 9.752-5.616.104-9.44 4.76-9.718 9.994-4.58-.432-4.984 2.951-5.742 6.294-.31 1.36-1.321 2.735-2.375 3.714-1.828 1.699-4.03 2.99-5.913 4.639-5.32 4.66-3.84 13.24-10.56 17.649-2.01 1.318-1.634 6.7-4.612 9.615-1.187 1.163-.195 4.55-.195 6.923l-1-.9c-1.15 1.096-2.98 2.003-3.344 3.317-3.225 11.637-9.817 22.583-7.548 35.399.103.578-.284 1.259-.494 1.875-1.061 3.11-2.75 6.15-3.075 9.333-.556 5.442-.27 10.972-.323 16.465-.164 16.716-.522 33.448 3.466 49.873.186.768.712 1.446.969 2.204.586 1.725 1.14 3.463 1.642 5.215 1.342 4.694 1.303 10.72 4.3 13.777 4.11 4.192 5.184 8.567 5.63 13.658.395 4.515 2.199 7.543 7.405 7.697.195 10.635 4.905 18.689 13.115 24.549.117 1.254-.244 2.919.426 3.695 5.318 6.17 10.559 12.45 16.362 18.148 5.974 5.866 12.442 11.252 18.908 16.59 4.729 3.903 9.648 7.626 14.784 10.965 2.836 1.844 8.359-.645 8.763 5.415.002.039 2.167-.37 3.132-.03 2.026.713 4.062 1.58 5.836 2.768 1.688 1.13 2.819 3.413 4.595 4.024 4.233 1.456 8.707 2.207 13.072 3.29.589.146 1.579.55 1.59.863.152 4.088 3.836 2.98 5.943 3.928 2.38 1.072 5.053 1.607 7.654 2.057 11.346 1.962 22.703 5.29 34.074 5.365 19.129.124 38.503 1.862 58.214-3.411z"
    />
    <path
      fill="#FFF"
      opacity={1}
      d="M412.87 1029.413c-1.36.016-2.721.031-4.84-.077a481.503 481.503 0 01-7.717-1.7s-.077.086-.268-.234c-3.48-1.557-6.767-2.795-10.055-4.032a9.392 9.392 0 01-1.768-.428c-.45-.224-.87-.25-.87-.25s-.036-.11-.289-.324c-.793-.72-1.605-1.127-1.83-1.746-1.58-4.36-4.942-5.686-9.255-3.537 0 0-.295-.217-.597-.525-.65-.43-.997-.55-1.345-.67-1.515-.836-3.03-1.671-4.948-2.988-1.23-.739-2.056-.996-2.881-1.253 0 0-.296-.318-.542-.781.068-5.29-4.741-3.07-6.516-5.024 0 0-.105.075-.073-.23-.264-.52-.56-.736-.855-.95-.136-.116-.271-.232-.62-.55-.213-.201-.563-.168-.563-.168-.793-.854-1.585-1.708-2.756-3.067-1.032-.913-1.687-1.32-2.342-1.729 0 0-.013-.085-.128-.301-.288-.506-.54-.679-.872-.736 0 0 .026-.06-.04-.317-.348-.427-.63-.598-.91-.768-.582-.508-1.163-1.016-1.956-2.057-1.2-1.255-2.19-1.976-3.179-2.697 0 0 .02-.111-.093-.44-.965-1.198-1.816-2.067-2.668-2.937 0 0-.083.063-.061-.237-.256-.533-.533-.765-.81-.998 0 0-.294-.355-.52-.641-.358-.53-.561-.638-.837-.61-.176-.339-.351-.678-.87-1.446a28.774 28.774 0 00-2.048-1.864s.029-.058-.034-.36c-.431-.767-.8-1.233-1.17-1.699-.022-.447-.046-.894.018-1.963-.163-1.129-.414-1.635-.665-2.142 0 0-.016-.054-.32-.27-5.795-1.44-2.606-6.184-3.91-9.105-4.425-1.296-4.425-1.296-5.018-7.592.022-.421.044-.842-.036-1.893-.685-.69-1.269-.75-1.852-.809-.194-.031-.389-.063-.956-.545-.83-2.7-1.053-5.034-1.803-7.183-1.157-3.317-2.676-6.507-4.042-9.752 0 0-.125-.394-.356-.947-.331-5.13-.196-9.73-.633-14.274-.206-2.153-1.508-4.2-2.314-6.296 0 0-.045-.145-.182-.516-.368-1.843-.6-3.315-.832-4.787-.01-.74-.02-1.48-.055-2.938-.206-2.17-.388-3.62-.57-5.072.132-7.69.263-15.38.62-23.889.303-5.35.38-9.883.455-14.415.035-1.527.07-3.053.236-5.25 4.792-6.02 2.41-11.75 1.034-17.426.047-1.068.094-2.136.378-3.822.3-1.182.36-1.746.422-2.31.138-.407.275-.814.607-1.9.533-3.73.873-6.78 1.213-9.828 0 0-.158-.055.063-.386.157-1.85.094-3.371.03-4.892.133-.409.265-.818.581-1.777.298-1.108.41-1.667.524-2.225.13-.404.261-.808.552-1.77.202-1.118.244-1.676.286-2.235.179-.696.358-1.392.62-2.832.317-2.865.55-4.988.783-7.11.073-.17.147-.342.36-.845.266-.606.21-.821-.03-.977 2.286-7.116 5.735-13.855 5.177-21.791-.212-3.008 1.826-6.144 2.682-9.264 1.237-4.508 2.069-9.143 3.545-13.567 2.506-7.51 5.298-14.93 8.164-22.312.602-1.55 2.038-2.778 2.779-3.747.72-2.485 1.013-4.837 2.039-6.808 4.113-7.906 8.252-15.813 12.811-23.463 1.729-2.9 4.842-4.942 6.905-7.69 1.532-2.04 2.087-4.817 3.633-6.84 1.445-1.891 3.623-3.22 6.175-5.39.847-5.897 2.828-7.896 9.656-8.46.472-5.846 2.986-10 10.014-9.787-.221-7.219 4.97-6.311 9.461-6.199 1.573-5.717 14.19-12.555 18.704-11.198 2.212-1.887 3.684-4.02 5.652-4.686 18.726-6.336 37.864-10.757 57.785-9.654 4.765.264 9.87 1.699 14.037 4.007 9.501 5.264 18.573 11.32 27.694 17.246 2.24 1.456 4.584 3.321 5.862 5.575 2.753 4.856 8.128 4.765 12.143 7.114 6.076 3.555 12.687 6.207 19.113 9.15 4.555 2.087 9.848 2.755 13.017 7.44.549.811 2.465.742 3.766.995 9.99 1.937 19.91 4.512 29.992 5.612 12.803 1.396 25.776 2.551 38.603 2.028 12.28-.501 24.963-1.781 36.513-5.604 7.45-2.466 14.843-3.027 22.112-4.617 3.752-9.279 12.857-7.701 19.337-10.805 1.68-1.605 3.152-3.539 5.076-4.757 8.005-5.066 16.199-9.832 24.215-14.88 4.198-2.643 7.95-6.077 12.337-8.301 2.274-1.153 5.491-.449 8.682-.602-.47-5.468 3.066-5.946 7.164-7.477 11.45-4.276 22.472-2.347 33.692.123 1.433.316 2.99.035 4.488.09 1.493.055 3.298-.329 4.424.362 8.631 5.295 19.663 3.26 27.966 9.09 4.988 3.5 12.396 3.23 15.314 9.87 5.379-.568 7.904 4.034 11.634 6.443 3.442 2.224 7.007 4.317 10.16 6.902 1.61 1.32 2.437 3.593 4.161 6.284 3.677 1.39 8.217 3.44 8.487 9.658.031.715.586 1.735 1.19 2.048 6.531 3.376 10.392 8.477 10.99 15.961.065.82 1.206 1.645 1.99 2.296 1.288 1.07 3.256 1.705 3.946 3.038 2.572 4.965 4.683 10.166 7.104 15.213.547 1.14 1.62 2.038 2.504 2.999.424.461 1.327.75 1.406 1.22 1.193 7.038 6.726 12.98 5.166 20.737-.349 1.735-.051 3.6-.051 5.716 5.116.047 7.83 1.6 5.282 6.828-.337.693.141 2.615.419 2.652 4.82.646 2.986 4.446 3.894 7.172 1.327 3.986 3.413 7.65 1.952 12.025 6.593 2.496 1.96 9.106 4.864 13.516 2.512 3.816 1.351 9.94 2.215 14.976 1.843 10.755 4.742 21.39 5.75 32.211 1.416 15.19 1.78 30.496 2.07 45.763.207 11.001-.082 22.042-.81 33.022-.666 10.03-1.118 20.147-6.606 29.298-2.194 3.658-2.976 8.284-3.843 12.581-.81 4.023-2.802 6.19-5.546 6.26-2.837 4.105-5.236 7.37-7.363 10.804-.524.845.008 2.279-.242 3.375-.36 1.58-.676 4.22-1.554 4.465-6.823 1.905-6.394 9.93-11.694 13.205-4.88 3.015-8.17 8.902-15.913 7.35 2.512 4.104.512 5.556-2.692 6.739-1.972.727-5.155.083-5.315 3.618-.005.116-.228.312-.359.32-9.6.55-15.304 10.028-25.116 10.663-5.203.337-10.211 3.07-15.419 4.215-2.782.611-5.803.09-8.713.186-2.552.083-6.095-.674-7.445.684-2.937 2.955-6.067 1.916-9.24 2.176-5.003.408-9.992 1.41-14.988 1.413-124.48.08-248.958.075-373.437.012-4.386-.002-9.88.743-12.886-1.5-4.029-3.007-7.84-1.859-12.46-2.225-2.204.182-3.68.045-5.158-.092-.453.016-.906.032-1.986-.098-2.138-.96-3.648-1.774-5.16-2.588z"
    />
    <path
      fill="#FFFEFE"
      opacity={1}
      d="M677.157 622.071c-19.298 5.197-38.672 3.459-57.8 3.335-11.372-.074-22.729-3.403-34.075-5.365-2.601-.45-5.274-.985-7.654-2.057-2.107-.949-5.791.16-5.942-3.928-.012-.313-1.002-.717-1.59-.863-4.366-1.083-8.84-1.834-13.073-3.29-1.776-.611-2.907-2.893-4.595-4.024-1.774-1.188-3.81-2.055-5.836-2.768-.965-.34-3.13.069-3.132.03-.404-6.06-5.927-3.571-8.763-5.415-5.136-3.339-10.055-7.062-14.784-10.966-6.466-5.337-12.934-10.723-18.908-16.59-5.803-5.697-11.044-11.977-16.362-18.147-.67-.776-.309-2.44-.426-3.695-8.21-5.86-12.92-13.914-13.115-24.55-5.206-.153-7.01-3.18-7.405-7.696-.446-5.09-1.52-9.466-5.63-13.658-2.997-3.058-2.958-9.083-4.3-13.777a111.906 111.906 0 00-1.642-5.215c-.257-.758-.783-1.436-.97-2.204-3.987-16.425-3.629-33.157-3.465-49.873.054-5.493-.233-11.023.323-16.465.325-3.182 2.014-6.224 3.075-9.333.21-.616.597-1.297.494-1.875-2.269-12.816 4.323-23.762 7.548-35.399.364-1.314 2.194-2.221 3.344-3.317l1 .9c0-2.374-.992-5.76.195-6.923 2.978-2.916 2.602-8.297 4.611-9.615 6.72-4.408 5.24-12.989 10.561-17.65 1.882-1.648 4.085-2.939 5.913-4.638 1.054-.979 2.066-2.353 2.375-3.714.758-3.343 1.162-6.726 5.742-6.294.278-5.234 4.102-9.89 9.718-9.994.542-5.786 3.921-8.982 10.003-9.752.054-7.465 5.312-5.05 9.383-4.556.884-2.647 1.009-6.029 2.668-7.16 1.763-1.201 4.98-.27 8.031-.27-1.355-7.4 3.298-8.882 8.494-10.369 2.516-.72 4.647-2.762 6.972-4.174 3.389-2.057 6.566-4.647 11.01-3.852.806.145 2.194-.28 2.58-.9 3.48-5.592 9.697-5.897 15.001-7.862 5.261-1.948 10.955-1.8 16.299-4.44 4.673-2.308 10.627-2.105 16.042-2.808 7.977-1.036 15.957-2.294 23.975-2.699 6.423-.324 12.962-.001 18.926 3.276 1.209.664 2.921.739 4.36.61 11.991-1.08 23.319 1.073 34.383 5.863 7.048 3.052 14.964 4.247 21.749 7.723 10.881 5.575 21.451 11.902 31.574 18.765 7.717 5.232 14.537 11.788 21.797 17.788l-2.64 2.673c.93.823 1.908 2.403 2.78 2.346 5.346-.35 7.842 3.515 10.584 6.864 5.792 7.073 11.809 14.014 16.973 21.532 4.772 6.947 8.89 14.407 12.638 21.967 2.191 4.42 3.033 9.5 4.604 14.242.642 1.937 1.67 3.742 2.407 5.652.513 1.329 1.139 2.727 1.164 4.104.04 2.148-.658 4.354 2.37 5.172.472.127.76 1.402.91 2.19 1.048 5.479 2.211 10.944 3.005 16.462 1.11 7.716 2.363 15.45 2.78 23.22.811 15.074.638 30.126-3.469 44.874-1.101 3.956-1.191 8.2-2.369 12.126-2.287 7.623-5.021 15.113-7.556 22.662-.5 1.489-.935 2.998-1.488 4.782-4.451.278-4.582 2.963-4.676 7.091-.081 3.55-2.805 7.086-4.54 10.538-1.279 2.547-2.68 5.068-4.331 7.384-1.655 2.32-3.67 4.386-5.576 6.52-.277.31-1.121.29-1.206.572-3.385 11.332-13.778 17.338-20.264 26.338-3.372 4.679-9.271 7.518-13.949 11.288-1.085.875-1.687 2.355-2.78 3.214-4.367 3.433-8.189 8.173-13.78 6.455-.812 2.316-.9 4.833-2.053 5.497-7.903 4.549-15.92 8.934-24.13 12.894-3.823 1.844-8.118 2.801-12.289 3.773-1.23.287-3.054-1.458-4.107-1.033-2.157.87-4.312 1.284-6.276 3.666-2.254 2.735-7.216 3.237-11.415 4.785z"
    />
    <path
      fill="#EB7872"
      opacity={1}
      d="M376.112 1017.39c4.179-2.454 7.541-1.129 9.122 3.232.224.62 1.036 1.026 1.774 1.762a137.17 137.17 0 01-10.896-4.993zM313.922 918.578c.74 1.788 2.043 3.836 2.25 5.989.436 4.545.3 9.145.493 14.12-.664-3.324-1.586-7.023-2.126-10.777-.428-2.973-.386-6.014-.617-9.332zM314.414 844.316c1.526 5.338 3.907 11.068-.954 16.713.134-5.263.47-10.82.954-16.713zM325.66 960.3c.782 5.966.782 5.966 5.207 7.262 1.304 2.921-1.885 7.665 3.884 9.115-.678.242-2.463.334-2.47.265-.554-6.168-8.8-9.139-6.621-16.641zM317.155 940.196c1.37 2.837 2.89 6.027 4.047 9.344.75 2.15.972 4.482 1.513 7.132-1.8-5.09-3.683-10.58-5.56-16.476zM313.12 867.06c.097 4.126.02 8.659-.245 13.547-.102-4.143-.015-8.642.245-13.547zM390.255 1023.56a144.88 144.88 0 019.807 3.787c-3.043-1.022-6.293-2.31-9.807-3.787zM316.905 826.361c-.062 2.806-.402 5.855-.913 9.262.098-2.768.366-5.893.913-9.262zM359.206 1006.17c1.718 1.628 6.527-.591 6.263 4.604-2.036-1.18-4.121-2.73-6.263-4.604zM320.354 803.092c.035 1.921-.198 4.044-.55 6.547.014-1.86.148-4.104.55-6.547zM412.844 1029.672c1.537.555 3.047 1.37 4.847 2.359-1.432-.583-3.152-1.342-4.847-2.36zM420.267 1032.285c1.225-.05 2.702.088 4.504.099-1.201-.055-2.727.016-4.504-.1zM400.51 1027.925c2.122.237 4.442.763 7.115 1.475a49.584 49.584 0 01-7.115-1.475zM317.073 821.061c.267 1.3.33 2.82.253 4.69-.246-1.257-.352-2.863-.253-4.69zM312.041 905.2c.36 1.21.54 2.66.64 4.474-.327-1.17-.572-2.7-.64-4.474zM312.682 913.241c.393 1.2.625 2.671.917 4.512-.319-1.167-.698-2.702-.917-4.512zM344.892 992.592c.952.403 1.942 1.124 2.963 2.15-.954-.407-1.94-1.12-2.963-2.15zM342.124 989.214c.822.553 1.673 1.422 2.586 2.598-.812-.557-1.684-1.419-2.586-2.598zM319.036 812.944c.141.448.1 1.006-.107 1.8-.134-.406-.105-1.048.107-1.8zM337.003 983.393c.514.186 1.082.665 1.757 1.407-.497-.196-1.1-.656-1.757-1.407zM335.646 981.25c.468.258.837.724 1.236 1.492-.425-.228-.88-.757-1.236-1.493zM315.176 837.95c.126.46.064 1.024-.193 1.807-.128-.422-.06-1.062.193-1.807zM318.17 816.919c.098.477-.015 1.036-.305 1.82-.086-.429.004-1.084.305-1.82zM352.068 999.416c.527.142 1.182.55 1.946 1.235-.533-.138-1.175-.554-1.946-1.235zM366.392 1011.915c.64-.009 1.466.248 2.426.805-.657.02-1.45-.26-2.426-.805zM335.076 977.216c.272.228.523.734.642 1.53-.308-.225-.485-.738-.642-1.53zM324.148 957.443c.396-.115.98-.056 1.595.324-.448.164-.928.008-1.595-.324zM387.34 1022.83c.013-.138.432-.112.552.06.12.172-.242.31-.242.31s-.322-.23-.31-.37zM320.886 801.253c.306-.028.362.187.121.514-.114.053-.189-.33-.121-.514zM374.194 1016.112c.19-.102.537.018 1.011.397-.2.114-.526-.03-1.011-.397zM358.303 1004.918c.213-.04.509.175.834.676-.232.05-.492-.186-.834-.676zM357.023 1004.036c.015-.09.365-.123.329-.017-.037.107-.344.107-.33.017zM351.002 998.344c.27-.174.522 0 .767.512-.27.183-.529.015-.767-.512zM350.07 997.255c.2-.057.482.114.796.54-.295.17-.545-.019-.796-.54zM341.29 987.921c.21-.026.487.206.791.72-.223.035-.473-.213-.79-.72zM339.894 986.588c.248-.205.45-.097.603.327-.246.194-.445.083-.603-.327z"
    />
  </svg>
);

export const trashIcon = (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.425 5h18.702M6.62 5V3c0-.53.22-1.04.609-1.414A2.12 2.12 0 018.699 1h4.155c.552 0 1.08.21 1.47.586.39.375.608.884.608 1.414v2m3.117 0v14c0 .53-.218 1.04-.608 1.414a2.12 2.12 0 01-1.47.586H5.581a2.12 2.12 0 01-1.47-.586A1.963 1.963 0 013.504 19V5H18.05z"
      stroke="#6F75BC"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const deleteNotificationIcon = (
  <svg
    width={22}
    height={22}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.425 5h18.702M6.62 5V3c0-.53.22-1.04.609-1.414A2.12 2.12 0 018.699 1h4.155c.552 0 1.08.21 1.47.586.39.375.608.884.608 1.414v2m3.117 0v14c0 .53-.218 1.04-.608 1.414a2.12 2.12 0 01-1.47.586H5.581a2.12 2.12 0 01-1.47-.586A1.963 1.963 0 013.504 19V5H18.05z"
      stroke="#6F75BC"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const envelopeOpenIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#a)">
      <path
        d="M3 20V8.588a1 1 0 01.514-.874l8-4.444a1 1 0 01.972 0l8 4.444a1 1 0 01.514.874V20a1 1 0 01-1 1H4a1 1 0 01-1-1z"
        stroke="currentColor"
        strokeLinejoin="round"
      />
      <path d="M3 8.5l9 5 9-5" stroke="currentColor" strokeLinejoin="round" />
    </g>
  </svg>
);

export const verticalEllipsisIcon = (
  <svg
    width="64px"
    height="64px"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="currentColor"
      d="M8 2.5a1.22 1.22 0 011.25 1.17A1.21 1.21 0 018 4.84a1.21 1.21 0 01-1.25-1.17A1.22 1.22 0 018 2.5zm0 8.66a1.17 1.17 0 11-1.25 1.17A1.21 1.21 0 018 11.16zm0-4.33a1.17 1.17 0 110 2.34 1.17 1.17 0 110-2.34z"
    />
  </svg>
);

export const partyIcon = (
  <svg
    width="100px"
    height="100px"
    viewBox="0 0 64 64"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    fill="#64CAA1"
  >
    <g
      color="#64CAA1"
      fill="#64CAA1"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={4.1}
    >
      <path
        d="M306.52 28.428c-.652.012-1.285.197-1.766.677a2.162 2.162 0 00-.438.641 1 1 0 00-.01.014l-12.238 27.63a1 1 0 001.318 1.32l27.555-12.206a1 1 0 00.031-.018c.254-.107.492-.255.7-.463.64-.64.757-1.554.636-2.416-.12-.862-.463-1.778-.974-2.77-1.023-1.98-2.738-4.253-4.94-6.454-2.201-2.202-4.471-3.915-6.453-4.938-.99-.51-1.907-.856-2.77-.976a4.186 4.186 0 00-.652-.041zm.05 1.996c.09 0 .196.007.325.025.514.072 1.269.33 2.128.774 1.72.887 3.878 2.494 5.957 4.574 2.08 2.08 3.69 4.24 4.577 5.959.443.86.7 1.612.771 2.127.072.515-.027.684-.07.726-.043.043-.212.144-.727.073-.515-.072-1.269-.328-2.129-.772-1.72-.887-3.879-2.496-5.959-4.576-2.08-2.08-3.687-4.237-4.574-5.957-.443-.86-.7-1.614-.771-2.129-.053-.374-.014-.563.027-.656l.01-.02v-.002a.247.247 0 01.033-.05c.032-.032.135-.096.403-.096zm-1.793 3.213c.098.215.202.433.317.656 1.022 1.982 2.734 4.253 4.935 6.455 2.202 2.202 4.476 3.915 6.457 4.938.222.114.438.217.653.314l-7.71 3.414c-1.635-.96-3.511-2.441-5.245-4.174a30.656 30.656 0 01-3.004-3.482zm-4.52 10.205c.758.952 1.604 1.9 2.513 2.81 1.448 1.448 2.978 2.73 4.46 3.737l-12.285 5.443zM341.629 26.143c-5.453-.473-9.993 1.468-13.307 3.83-4.418 3.149-6.822 7.068-6.822 7.068a1 1 0 00.328 1.377 1 1 0 001.375-.328s2.22-3.595 6.28-6.488c4.06-2.894 9.795-5.062 17.177-2.24a1 1 0 001.291-.577 1 1 0 00-.576-1.29c-2.01-.769-3.928-1.195-5.746-1.352zM332.387 8.055a1 1 0 00-1.088.902s-.402 4.205-2.764 8.596c-2.361 4.39-6.547 8.873-14.416 9.607a1 1 0 00-.902 1.088 1 1 0 001.088.902c8.566-.8 13.422-5.872 15.992-10.65 2.57-4.778 2.992-9.357 2.992-9.357a1 1 0 00-.902-1.088zM310.213 15.604c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.564 0 1 .435 1 1 0 .564-.436 1-1 1-.564 0-1-.436-1-1 0-.565.436-1 1-1zM343.428 7.752a3.633 3.633 0 00-3.617 3.617 3.633 3.633 0 003.617 3.617 3.633 3.633 0 003.617-3.617 3.633 3.633 0 00-3.617-3.617zm0 2c.904 0 1.617.712 1.617 1.617s-.713 1.617-1.617 1.617a1.603 1.603 0 01-1.617-1.617c0-.905.712-1.617 1.617-1.617zM345.018 45.775c-1.645 0-3 1.355-3 3s1.355 3 3 3 3-1.355 3-3-1.355-3-3-3zm0 2c.564 0 1 .436 1 1 0 .565-.436 1-1 1-.565 0-1-.435-1-1 0-.564.435-1 1-1zM323.254 7.836a1 1 0 00-1 1v1.387h-1.387a1 1 0 00-1 1 1 1 0 001 1h1.387v1.386a1 1 0 001 1 1 1 0 001-1v-1.386h1.387a1 1 0 001-1 1 1 0 00-1-1h-1.387V8.836a1 1 0 00-1-1zM335.436 17.988a1 1 0 00-.707.293 1 1 0 000 1.414l.98.98-.98.981a1 1 0 000 1.414 1 1 0 001.414 0l.98-.98.98.98a1 1 0 001.415 0 1 1 0 000-1.414l-.98-.98.98-.98a1 1 0 000-1.415 1 1 0 00-.707-.293 1 1 0 00-.707.293l-.98.98-.981-.98a1 1 0 00-.707-.293zM336.424 36.18a1 1 0 00-1 1v1.386h-1.387a1 1 0 00-1 1 1 1 0 001 1h1.387v1.387a1 1 0 001 1 1 1 0 001-1v-1.387h1.387a1 1 0 001-1 1 1 0 00-1-1h-1.387V37.18a1 1 0 00-1-1zM327.123 45.207a1 1 0 00-.861 1.123 1 1 0 001.123.86c.279-.037.564-.037.844 0 .322.042.623.135.875.27.249.136.46.32.595.524.134.2.205.439.201.641a.822.822 0 01-.191.514c-.074.08-.194.167-.348.232a2.475 2.475 0 01-.578.15c-.454.071-1.04.067-1.726.204a5.228 5.228 0 00-2.88 1.652 5.228 5.228 0 00-1.298 3.055 5.224 5.224 0 00.807 3.218 5.23 5.23 0 002.585 2.082 5.23 5.23 0 003.319.1 5.224 5.224 0 002.705-1.922 5.228 5.228 0 00.998-3.166 5.227 5.227 0 00-1.113-3.127 1 1 0 00-1.405-.168 1 1 0 00-.168 1.405c.425.54.673 1.24.686 1.927a3.273 3.273 0 01-.615 1.951 3.275 3.275 0 01-1.668 1.186c-.658.199-1.4.176-2.045-.063a3.279 3.279 0 01-1.596-1.283c-.37-.578-.55-1.3-.496-1.984.054-.685.345-1.37.8-1.883a3.275 3.275 0 011.776-1.017c.423-.085.978-.087 1.64-.19.333-.052.692-.132 1.056-.287a2.968 2.968 0 001.04-.72 2.767 2.767 0 00.715-1.835 3.119 3.119 0 00-.539-1.783c-.34-.51-.8-.898-1.304-1.172a4.52 4.52 0 00-1.567-.494 5.211 5.211 0 00-1.367 0zM301.021 4.111a3.396 3.396 0 00-1.748.006 3.396 3.396 0 00-1.515.871 1 1 0 00-.004 1.416 1 1 0 001.414.004c.17-.168.394-.297.625-.36.23-.061.49-.062.72-.001.232.06.455.188.626.355.17.168.302.391.367.621.114.409.038 1.026-.004 1.825-.021.401-.024.854.082 1.34.107.491.325 1.006.738 1.433.347.359.787.605 1.273.715a2.542 2.542 0 002.62-.984c.294-.403.461-.877.486-1.375a1 1 0 00-.95-1.05 1 1 0 00-1.048.95.583.583 0 01-.106.297.578.578 0 01-.25.19.576.576 0 01-.312.02.579.579 0 01-.274-.154 1.007 1.007 0 01-.222-.468 3.152 3.152 0 01-.041-.809c.033-.639.207-1.493-.067-2.47a3.402 3.402 0 00-2.41-2.372z"
        transform="translate(-288)"
      />
    </g>
  </svg>
);

export const closeNotificationIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.775"
    height="7.775"
    viewBox="0 0 7.775 7.775"
  >
    <g
      id="Group_18235"
      data-name="Group 18235"
      transform="translate(-2.409 -8.639)"
    >
      <g
        id="Group_20988"
        data-name="Group 20988"
        transform="translate(3.399 9.629)"
      >
        <path
          id="Path_21521"
          data-name="Path 21521"
          d="M5035.352,5196.5l5.794,5.795"
          transform="translate(-5035.352 -5196.5)"
          fill="#5a5d5d"
          stroke="#5b5d5d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
        <path
          id="Path_21522"
          data-name="Path 21522"
          d="M5041.146,5196.5l-5.794,5.795"
          transform="translate(-5035.352 -5196.5)"
          fill="#5a5d5d"
          stroke="#5b5d5d"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.4"
        />
      </g>
    </g>
  </svg>
);

export const programNewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={29}
    height={28}
    viewBox="0 0 29 28"
    strokeWidth={1.5}
  >
    <g
      stroke="currentColor"
      fill="none"
      fillRule="evenodd"
      strokeLinejoin="round"
    >
      <path d="M15.241 18.285L2.324 11.001a1.592 1.592 0 01-.765-.937 1.213 1.213 0 01-.057-.413c0-1.008.488-1.627 1.52-2.209L15.326.5l12.179 6.872a.641.641 0 010 1.123l-11.31 6.38c-1.03.583-1.519 1.202-1.519 2.21s.885 1.8 1.916 1.217L28.5 11.584m-7 11.916l7-4m-14 7L1.343 18.415c-.375-.207-.667-.538-.783-.936a1.263 1.263 0 01-.058-.412c0-1.008.5-1.626 1.555-2.207l.58-.36" />
      <path d="M28.5 15.5l-12.89 7.593c-1.029.606-1.516 1.25-1.516 2.298 0 1.049.883 1.872 1.912 1.267l2.996-1.755V27.5l2.268-1.384v-2.567c0-.593-.24-1.057-.744-1.35" />
    </g>
  </svg>
);

export const usersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    viewBox="0 0 16.5 16.5"
  >
    <g
      data-name="user (1)"
      transform="translate(-3.3 -2.3)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 1"
        d="M17 17.625v-2c0-2.209-1.455-4-3.25-4h-6.5c-1.795 0-3.25 1.791-3.25 4v2"
      />
      <circle
        data-name="Ellipse 1"
        cx={4}
        cy={4}
        r={4}
        transform="translate(6.5 3)"
      />
    </g>
  </svg>
);

export const assignmentDarkIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={11.4}
    height={14.701}
    viewBox="0 0 11.4 14.701"
  >
    <g
      data-name="Group 20471"
      transform="translate(-19280.301 14499.974)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
    >
      <path
        data-name="Subtraction 6"
        d="M19289.5-14485.974h-7a1.5 1.5 0 01-1.5-1.5v-9a1.5 1.5 0 011.5-1.5h1.142v.925a.8.8 0 00.8.8h3.114a.8.8 0 00.8-.8v-.925h1.144a1.5 1.5 0 011.5 1.5v9a1.5 1.5 0 01-1.5 1.5z"
      />
      <g data-name="Rectangle 11033" transform="translate(19283 -14499.974)">
        <rect width={6} height={4} rx={1.5} stroke="none" />
        <rect x={0.7} y={0.7} width={4.6} height={2.6} rx={0.8} />
      </g>
      <path
        data-name="Line 1435"
        transform="translate(19283.557 -14492.914)"
        strokeLinecap="round"
        d="M0 0L5.114 0"
      />
      <path
        data-name="Line 1436"
        transform="translate(19283.557 -14489.99)"
        strokeLinecap="round"
        d="M0 0L5.114 0"
      />
    </g>
  </svg>
);

export const coursePlayIcon = (
  <svg
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    width="16px"
    height="16px"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
  >
    <path d="M20 24H4c-2.2 0-4-1.8-4-4V4c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4zM4 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4z" />
    <path d="M9 17c-.2 0-.3 0-.5-.1-.3-.2-.5-.5-.5-.9V8c0-.4.2-.7.5-.9.3-.2.7-.2 1 0l7 4c.3.2.5.5.5.9s-.2.7-.5.9l-7 4c-.2.1-.3.1-.5.1zm1-7.3v4.6l4-2.3-4-2.3z" />
  </svg>
);

export const resourceIcon = (
  <svg
    width={16}
    height={16}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      clipPath="url(#clip0_4_155)"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={0.000853333}
    >
      <path d="M18.115 0H5.075c-1.042 0-1.89.72-1.89 1.606V2.71H1.89C.847 2.709 0 3.429 0 4.315v10.996c0 .43.194.83.551 1.134l3.63 3.087A2.05 2.05 0 005.516 20h9.41c1.042 0 1.89-.72 1.89-1.606V17.29h1.296c1.042 0 1.889-.72 1.889-1.606V1.606C20 .72 19.153 0 18.115 0zM4.362 18.106L2.237 16.3h2.125v1.807zm11.146.288c0 .271-.26.492-.579.492H5.663V15.74c0-.307-.291-.555-.653-.555h-3.7V4.311c0-.272.26-.492.58-.492h13.04c.319 0 .578.22.578.492v14.083zm2.607-2.213H16.82V4.311c0-.886-.848-1.606-1.89-1.606H4.496V1.602c0-.271.26-.492.58-.492H18.11c.32 0 .578.22.578.492V15.69h.005c0 .272-.26.492-.579.492z" />
      <path d="M13.698 5.11H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.307-.292-.555-.648-.555zM13.698 7.953H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555 0-.307-.292-.555-.648-.555zM13.698 10.8H8.062c-.361 0-.653.247-.653.554 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.307-.292-.555-.648-.555zM13.698 13.642H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.307-.292-.555-.648-.555zM13.698 16.484H8.062c-.361 0-.653.248-.653.555 0 .307.292.555.653.555h5.63c.362 0 .654-.248.654-.555.005-.303-.292-.555-.648-.555zM5.737 4.807H3.126c-.361 0-.653.248-.653.555v2.225c0 .307.292.555.653.555h2.611c.362 0 .653-.248.653-.555V5.362c0-.307-.291-.555-.653-.555zm-.653 2.22H3.78v-1.11h1.305v1.11zM5.737 9.004H3.126c-.361 0-.653.248-.653.555v2.22c0 .308.292.556.653.556h2.611c.362 0 .653-.248.653-.555V9.56c0-.308-.291-.556-.653-.556zm-.653 2.22H3.78v-1.11h1.305v1.11z" />
    </g>
    <defs>
      <clipPath id="clip0_4_155">
        <path fill="#fff" d="M0 0H20V20H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const formIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={18}
    viewBox="0 0 17 18"
  >
    <g
      data-name="Group 20470"
      transform="translate(-19302 14500)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
    >
      <g data-name="Rectangle 11031" transform="translate(19302 -14500)">
        <rect width={17} height={18} rx={3} stroke="none" />
        <rect x={0.7} y={0.7} width={15.6} height={16.6} rx={2.3} />
      </g>
      <path
        data-name="Line 1432"
        transform="translate(19307.5 -14494.899)"
        strokeLinecap="round"
        d="M0 0L6.322 0"
      />
      <path
        data-name="Line 1433"
        transform="translate(19307.5 -14491.19)"
        strokeLinecap="round"
        d="M0 0L6.322 0"
      />
      <path
        data-name="Line 1434"
        transform="translate(19307.5 -14487.479)"
        strokeLinecap="round"
        d="M0 0L4 0"
      />
    </g>
  </svg>
);

export const penEditIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="15.831"
    height="15.665"
    viewBox="0 0 15.831 15.665"
  >
    <path
      id="edit-2"
      d="M12.791,2.768a2.035,2.035,0,1,1,2.878,2.878L5.957,15.357,2,16.437,3.079,12.48Z"
      transform="translate(-1.3 -1.472)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const removeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="7.763"
    height="7.763"
    viewBox="0 0 7.763 7.763"
  >
    <g data-name="Group 17821" transform="translate(0.99 0.99)">
      <path
        id="Path_21632"
        data-name="Path 21632"
        d="M0,0V8.177"
        transform="translate(5.783 0) rotate(45)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
      <path
        id="Path_21633"
        data-name="Path 21633"
        d="M0,0V8.177"
        transform="translate(5.782 5.783) rotate(135)"
        fill="none"
        stroke="#eb7c7c"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.4"
      />
    </g>
  </svg>
);

export const cameraIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={17.818}
    viewBox="0 0 20 17.818"
  >
    <path
      d="M13.318.354a2.793 2.793 0 011.366 1.265l.122.212.452.867.015.024.014.021.038.053a1.188 1.188 0 00.778.36A3.9 3.9 0 0120 6.852l.005.2v5.795a4.971 4.971 0 01-4.754 4.965H4.97A4.97 4.97 0 010 13.063V7.052a3.9 3.9 0 013.9-3.9 1.191 1.191 0 00.778-.36l.007-.008.009-.012.049-.072.451-.866A2.965 2.965 0 016.682.354a15.7 15.7 0 016.636 0zM7.237 1.748a1.433 1.433 0 00-.636.646l-.093.161-.385.745-.095.171a2.078 2.078 0 01-.248.341 2.7 2.7 0 01-1.709.838l-.171.006-.164.006a2.4 2.4 0 00-2.23 2.226l-.006.164v5.795a3.47 3.47 0 003.28 3.465l.19.005h10.06a3.471 3.471 0 003.465-3.28l.005-.19V7.052a2.4 2.4 0 00-2.233-2.39l-.167-.006-.174-.007a2.694 2.694 0 01-1.706-.839 2.074 2.074 0 01-.246-.338l-.019-.032-.023-.04-.116-.218-.324-.628a1.867 1.867 0 00-.635-.762l-.094-.045-.119-.04a16.078 16.078 0 00-5.407.041zM10 6.2a3.929 3.929 0 11-3.929 3.929A3.929 3.929 0 0110 6.2zm0 1.5a2.429 2.429 0 102.429 2.429A2.429 2.429 0 0010 7.7zm5.5-2.2a1 1 0 01.117 1.993L15.5 7.5a1 1 0 01-.126-1.993z"
      fill="currentColor"
      transform="translate(-2 -3) translate(2 3)"
      data-name="Iconly/Light-Outline/Camera"
    />
  </svg>
);

export const tagCloseIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={7.764}
    height={7.764}
    viewBox="0 0 7.764 7.764"
  >
    <g
      data-name="Group 18380"
      fill="none"
      stroke="#979ba3"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21632"
        d="M5.784 0L0 5.784"
        transform="translate(.99 .99)"
      />
      <path
        data-name="Path 21633"
        d="M5.784 5.784L0 0"
        transform="translate(.99 .99)"
      />
    </g>
  </svg>
);

export const chervonDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={4}
    viewBox="0 0 9.718 4.631"
  >
    <path
      id="Path_40581"
      data-name="Path 40581"
      d="M7.756,2.95,3.879,0,0,2.95"
      transform="translate(8.737 3.931) rotate(180)"
      fill="none"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.4"
    />
  </svg>
);

export const clearFormIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15.246}
    height={12.65}
    viewBox="0 0 15.246 12.65"
  >
    <path
      d="M6 26.65v-1.9h11.858v1.9zm1.694-5.376v-1.9h11.858v1.9zM9.388 15.9V14h11.858v1.9z"
      transform="translate(-6 -14)"
      fill="#474b89"
    />
  </svg>
);

export const filterIcon = (
  <svg
    width={21}
    height={13}
    viewBox="0 0 21 13"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.076 1.5H.354M16.532 6.5H3.897M13.09 11.5H7.35"
      stroke="#1B1C21"
      strokeWidth={2}
    />
  </svg>
);

export const clearBtn = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={26}
    height={26}
    viewBox="0 0 26 26"
  >
    <g data-name="close" transform="translate(-1137 -293)">
      <rect
        data-name="Rectangle 753"
        width={26}
        height={26}
        rx={13}
        transform="translate(1137 293)"
        fill="#f7f8fa"
      />
      <g
        data-name="Group 17821"
        fill="none"
        stroke="#13171f"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.7}
      >
        <path
          data-name="Path 21632"
          d="M5.947 0L0 5.947"
          transform="translate(1147.027 303.027)"
        />
        <path
          data-name="Path 21633"
          d="M5.947 5.947L0 0"
          transform="translate(1147.027 303.027)"
        />
      </g>
    </g>
  </svg>
);

export const blackArrowDownIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={10}
    height={10}
    viewBox="0 0 9.718 4.631"
  >
    <path
      data-name="Path 40581"
      d="M7.756 2.95L3.879 0 0 2.95"
      transform="rotate(180 4.369 1.966)"
      fill="none"
      stroke="#13171f"
      strokeWidth="1.4"
    />
  </svg>
);

export const unitBankIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16.308}
    height={15.761}
    viewBox="0 0 16.308 15.761"
  >
    <g
      data-name="Group 27695"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1}
    >
      <path
        data-name="Path 49083"
        d="M25.081 502.652L18 506.192l7.081 3.54 7.081-3.54z"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49084"
        d="M18 513.273l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
      <path
        data-name="Path 49085"
        d="M18 509.732l7.081 3.54 7.08-3.54"
        transform="translate(-16.927 -501.852)"
      />
    </g>
  </svg>
);

export const collapseSectionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 30 30"
  >
    <defs>
      <marker orient="auto" refX={0} refY={0} overflow="visible">
        <path
          d="M8.72 4.03L-2.21.02 8.72-4c-1.75 2.37-1.74 5.62 0 8.03z"
          transform="matrix(.3 0 0 .3 -.69 0)"
          fill="#000"
          fillOpacity={1}
          stroke="#000"
          strokeOpacity={1}
        />
      </marker>
      <marker orient="auto" refX={0} refY={0} overflow="visible">
        <path
          d="M8.72 4.03L-2.21.02 8.72-4c-1.75 2.37-1.74 5.62 0 8.03z"
          transform="matrix(-.3 0 0 -.3 .69 0)"
          fill="#000"
          fillOpacity={1}
          stroke="#000"
          strokeOpacity={1}
        />
      </marker>
    </defs>
    <path
      style={{
        lineHeight: "normal",
        fontVariantLigatures: "normal",
        fontVariantPosition: "normal",
        fontVariantCaps: "normal",
        fontVariantNumeric: "normal",
        fontVariantAlternates: "normal",
        fontFeatureSettings: "normal",
        textIndent: 0,
        textAlign: "start",
        textDecorationLine: "none",
        textDecorationStyle: "solid",
        textDecorationColor: "#000",
        textTransform: "none",
        textOrientation: "mixed",
        whiteSpace: "normal",
        shapePadding: 0,
        isolation: "auto",
        mixBlendMode: "normal",
        solidColor: "#000",
        solidOpacity: 1,
      }}
      d="M6 296.017l6.96 6.96a3.015 3.015 0 004.243 0l6.961-6.96a12.05 12.05 0 00-1.422-1.406l-6.953 6.953a.976.976 0 01-1.414 0l-6.953-6.953c-.515.426-.985.9-1.422 1.406z"
      color="#000"
      fontStyle="normal"
      fontVariant="normal"
      fontWeight={400}
      fontStretch="normal"
      fontSize="medium"
      fontFamily="sans-serif"
      textDecoration="none"
      letterSpacing="normal"
      wordSpacing="normal"
      writingMode="lr-tb"
      direction="ltr"
      dominantBaseline="auto"
      baselineShift="baseline"
      textAnchor="start"
      clipRule="nonzero"
      display="inline"
      overflow="visible"
      visibility="visible"
      opacity={0.87000002}
      colorInterpolation="sRGB"
      colorInterpolationFilters="linearRGB"
      vectorEffect="none"
      fill="currentColor"
      fillOpacity={1}
      fillRule="nonzero"
      stroke="none"
      strokeWidth={2}
      strokeLinecap="butt"
      strokeLinejoin="miter"
      strokeMiterlimit={4}
      strokeDasharray="none"
      strokeDashoffset={0}
      strokeOpacity={1}
      colorRendering="auto"
      imageRendering="auto"
      shapeRendering="auto"
      textRendering="auto"
      transform="translate(0 -284.65)"
    />
  </svg>
);

export const builderPencilIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={22.65}
    viewBox="0 0 18.4 22.65"
  >
    <g data-name="Group 27311">
      <rect
        data-name="Rectangle 11637"
        width={17}
        height={21.25}
        rx={2}
        transform="translate(-972.8 -539.3) translate(969.5 538) translate(4 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      />
      <g
        data-name="Group 27310"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-972.8 -539.3)"
      >
        <g data-name="Group 27309">
          <g
            data-name="Group 27297"
            transform="translate(410 -47.979)"
            strokeWidth={1.4}
          >
            <path
              data-name="Line 1659"
              transform="translate(570 600.5)"
              d="M0 0L7 0"
            />
            <path
              data-name="Line 1662"
              transform="translate(567 600.5)"
              d="M0 0L0.006 0"
            />
          </g>
          <path
            data-name="Path 48809"
            d="M983.253 543.335a1.144 1.144 0 011.615 1.621l-5.115 5.134-2.153.541.538-2.162z"
            strokeWidth={1.3}
          />
        </g>
        <path
          data-name="Rectangle 11640"
          transform="translate(977 554.8)"
          strokeWidth={1.4}
          d="M0 0H10V3H0z"
        />
      </g>
    </g>
  </svg>
);

export const formBuilderIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18.4}
    height={22.65}
    viewBox="0 0 18.4 22.65"
  >
    <g data-name="Group 27305">
      <rect
        data-name="Rectangle 11637"
        width={17}
        height={21.25}
        rx={2}
        transform="translate(-846.3 -539.3) translate(843 538) translate(4 2)"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.4}
      />
      <g
        data-name="Group 27304"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <g data-name="Group 27301" strokeWidth={1.3}>
          <path
            data-name="Path 48806"
            d="M1028.976 552.18h-2.51c-.534 0-.966.28-.966.624v4.376c0 .345.432.624.966.624h6.759c.533 0 .966-.28.966-.624v-1.5"
            transform="translate(-846.3 -539.3) translate(-175.1 .112)"
          />
          <path
            data-name="Path 48807"
            d="M1034.4 549.791a.787.787 0 011.113 1.113l-3.529 3.525-1.484.371.371-1.484z"
            transform="translate(-846.3 -539.3) translate(-175.1 .112)"
          />
        </g>
        <g
          data-name="plus (2)"
          transform="translate(-846.3 -539.3) translate(853.35 543.2)"
          strokeWidth={1.4}
        >
          <path
            data-name="Line 1651"
            transform="translate(2.147)"
            d="M0 0L0 4.294"
          />
          <path
            data-name="Line 1652"
            transform="translate(0 2.147)"
            d="M0 0L4.294 0"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const offthejobIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.071}
    height={13}
    viewBox="0 0 12.071 13"
  >
    <g
      data-name="Group 20546"
      transform="translate(-19378 14497.885)"
      fill="none"
      stroke="currentColor"
    >
      <g
        data-name="Rectangle 11036"
        transform="translate(19378 -14494.885)"
        strokeWidth={1}
      >
        <rect width={12.071} height={10} rx={2} stroke="none" />
        <rect x={0.7} y={0.7} width={10.671} height={8.6} rx={1.3} />
      </g>
      <g
        data-name="Rectangle 11037"
        transform="translate(19381.535 -14497.885)"
        strokeWidth={1}
      >
        <rect width={5} height={4} rx={1} stroke="none" />
        <rect x={0.6} y={0.6} width={3.8} height={2.8} rx={0.4} />
      </g>
      <path
        data-name="Line 1437"
        transform="translate(19378.471 -14491.438)"
        strokeWidth={1.4}
        d="M0 0L11.305 0"
      />
    </g>
  </svg>
);

export const explainNoteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
  >
    <g
      transform="translate(.651 .902)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <circle
        data-name="Ellipse 36"
        cx={7}
        cy={7}
        r={7}
        transform="translate(.349 .098)"
        fill="#1b1c21"
        stroke="#1b1c21"
      />
      <path
        data-name="Line 161"
        transform="translate(7.349 7.098)"
        fill="none"
        stroke="#fff"
        d="M0 3L0 0"
      />
      <path
        data-name="Line 162"
        transform="translate(7.349 4.098)"
        fill="none"
        stroke="#fff"
        d="M0 0L0 0"
      />
    </g>
  </svg>
);

export const workflowIcon = (
  <svg
    id="Icon_Set"
    data-name="Icon Set"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36.87 37"
    strokeWidth={2}
  >
    <path
      d="M26.7 5.13V.5H15.53v19.2l-4.76-4.82L6 19.7V.5H1.55a1 1 0 00-1 1.05v33.9a1 1 0 001.05 1h10.72"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M17.25 0.5L6.31 0.5"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M34.06 28.1h-5.63v-1.57h.18a1.37 1.37 0 000-2.73 27.82 27.82 0 01.77-3.8c.25-.88.54-1.75.86-2.61.17-.45.35-.87.56-1.31a7.78 7.78 0 00.61-1.67 4.78 4.78 0 00-.4-3.26 5 5 0 00-8.85 0 4.89 4.89 0 00-.4 3.26 8.39 8.39 0 00.62 1.59c.21.44.39.86.56 1.31.32.86.61 1.73.85 2.61a26.45 26.45 0 01.8 3.84 1.37 1.37 0 000 2.73h.17v1.57h-5.64a2.31 2.31 0 00-2.32 2.31v2.66h19.57v-2.62a2.3 2.3 0 00-2.31-2.31z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M16.64 36.45L36.57 36.45"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

export const eventIcon = (
  <svg
    id="Icon_Set"
    data-name="Icon Set"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 51.98 45.62"
    strokeWidth={3}
  >
    <path
      d="M8.36 24.36l-5.3 4.36A7 7 0 00.5 34.13v11.4"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M27.55 24.45L31.69 27.86"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M9.06 35.83L9.04 39.56 9.04 45.53"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <circle
      cx="17.9"
      cy="11.51"
      r="11.01"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M26.75 35.83L26.77 39.56 26.77 45.53"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M35.42 16.12H51.48V45.12H35.42z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M39.44 25.12L47.46 25.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M39.44 31.12L44.02 31.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M40.51 38.79L42.66 40.34 47.19 35.99"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M39.44 28.12L47.46 28.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M47.53 16.12L47.53 20.62 39.37 20.62 39.37 16.12"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);

export const quizNewIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64.000000 66.000000">
    <path
      fill="currentColor"
      d="M72 648c-7-7-12-22-12-34 0-15-8-24-24-28-14-3-27-15-31-26-8-24 11-60 30-60 9 0 15-10 15-25 0-18-5-25-20-25-13 0-22-9-26-25-7-27 10-55 32-55 8 0 14-10 14-25 0-18-5-25-20-25-13 0-22-9-26-25-7-27 10-55 32-55 23 0 16-44-8-55-41-18-31-75 13-75 15 0 19-7 19-35 0-24 6-37 19-45 12-6 104-10 230-10h211v100c0 60-4 100-10 100s-10-35-10-85V50H90v26c0 14 10 34 22 43 27 22 19 71-12 71-15 0-20 7-20 25 0 15 6 25 14 25 22 0 39 28 32 55-4 16-13 25-26 25-15 0-20 7-20 25 0 15 6 25 14 25 22 0 39 28 32 55-4 16-13 25-26 25-29 0-27 42 3 55s34 50 8 72c-12 9-21 25-21 35 0 15 9 18 50 18h50V510c0-122 6-140 38-108 9 9 15 9 24 0 32-32 38-14 38 108v120h210v-55c0-30 5-55 10-55 6 0 10 30 10 70v70H302c-156 0-221-3-230-12zm188-113c0-88-1-95-20-95s-20 7-20 95 1 95 20 95 20-7 20-95zm-160 10c0-10-11-15-35-15s-35 5-35 15 11 15 35 15 35-5 35-15zm0-130c0-10-11-15-35-15s-35 5-35 15 11 15 35 15 35-5 35-15zm0-130c0-10-11-15-35-15s-35 5-35 15 11 15 35 15 35-5 35-15zm-2-132c-5-25-61-25-66 0-3 14 4 17 33 17s36-3 33-17z"
      transform="matrix(.1 0 0 -.1 0 66)"
    />
    <path
      fill="currentColor"
      d="M555 469c-4-6-19-7-36-4-25 6-36 0-87-49-40-38-54-58-47-65 8-8 26 4 60 39 27 28 56 50 64 50s-44-60-116-132C285 198 260 167 250 131c-12-46-8-60 12-44 7 6 27 13 43 17 20 5 78 55 183 159 83 83 152 157 152 163 0 16-44 54-63 54-9 0-19-5-22-11zm44-32c8-10 4-20-19-42-25-24-32-26-45-15-14 12-13 16 11 42 31 32 37 33 53 15zm-81-80c9-10-10-35-83-107-82-82-96-92-110-80s-6 24 77 107c51 51 96 93 99 93 4 0 11-6 17-13zM306 132c-22-5-30 3-21 18 5 8 11 7 22-2 15-12 14-13-1-16z"
      transform="matrix(.1 0 0 -.1 0 66)"
    />
  </svg>
);

export const reviewNewIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={36}
    height={39}
    viewBox="0 0 36 39"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <path d="M16.25.569c-.215-.498-.753-.71-1.202-.47L8.694 3.47c-.449.238-.638.835-.424 1.333.215.499.753.71 1.201.471l.41-.217 3.001 5.288-.906 2.609 3.83-2.034 3.83-2.033-2.397-.855-1.824-5.913.41-.218c.449-.238.639-.835.424-1.333zm-1.523 11.063l4.091 4.777-1.318-6.045" />
      <path d="M21.273 12.955l8.182 3.08L22.652 38 2.455 30.602l6.954-20.238" />
      <path d="M22.423 8.378l12.746 4.577L28.66 33.83l-3.386-1.504m-13.001-9.871l8.182 2.59m-9.819.865l8.182 2.59m2.174-12.955c.648 1.173.136 2.604-1.142 3.198-1.279.593-2.84.124-3.486-1.048" />
    </g>
  </svg>
);

export const externalIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2l5.09 10.26L22 12l-5.09 10.26L12 22l-5.09-10.26L2 12l5.09-10.26z"></path>
  </svg>
);

export const subSectionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={13}
    viewBox="0 0 13 13"
  >
    <g
      data-name="Group 20473"
      transform="translate(-19523.156 14527.022)"
      fill="none"
      stroke="currentColor"
      strokeWidth={1}
    >
      <g
        data-name="Rectangle 11038"
        transform="translate(19523.156 -14527.022)"
      >
        <rect width={13} height={13} rx={4} stroke="none" />
        <rect x={0.7} y={0.7} width={11.6} height={11.6} rx={3.3} />
      </g>
      <path
        data-name="Line 1438"
        transform="translate(19527.492 -14526.654)"
        d="M0 0L0 12.443"
      />
      <path
        data-name="Line 1439"
        transform="translate(19527.492 -14518.359)"
        d="M0 0L8.295 0"
      />
      <path
        data-name="Line 1440"
        transform="translate(19531.641 -14526.654)"
        d="M0 8.295L0 0"
      />
    </g>
  </svg>
);

export const openBookIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12.2}
    height={10.972}
    viewBox="0 0 12.2 10.972"
  >
    <g
      fill="#eaebf5"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 17"
        d="M0 0h3.24A2.144 2.144 0 015.4 2.127v7.445a1.608 1.608 0 00-1.62-1.6H0z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 18"
        d="M10.8 0H7.56A2.144 2.144 0 005.4 2.127v7.445a1.608 1.608 0 011.62-1.6h3.78z"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
);
export const filesIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={9.478}
    height={11.344}
    viewBox="0 0 9.478 11.344"
  >
    <g
      fill="#eaebf5"
      stroke="#6f75bc"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 39"
        d="M4.544 0H1.01A1 1 0 000 .994V8.95a1 1 0 001.01.994h6.058a1 1 0 001.01-.994V3.48z"
        transform="translate(.7 .7)"
      />
      <path
        data-name="Path 40"
        d="M4.544 0v3.48h3.534"
        transform="translate(.7 .7)"
      />
    </g>
  </svg>
);
export const administratorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g data-name="Group 27256" transform="translate(-31 -743)">
      <circle
        data-name="Ellipse 453"
        cx={96}
        cy={96}
        r={96}
        transform="translate(31 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27251" stroke="#6f75bc" strokeLinejoin="round">
        <g
          data-name="user (1)"
          transform="translate(60 792) translate(0 8.457)"
          fill="#6f75bc"
          strokeWidth={1.4}
        >
          <path
            data-name="Path 1"
            d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
          />
          <circle
            data-name="Ellipse 1"
            cx={23.257}
            cy={23.257}
            r={23.257}
            transform="translate(14.535)"
            strokeLinecap="round"
          />
        </g>
        <path
          data-name="key (1)"
          d="M131.392 0l-5.366 5.366m-20.418 20.416a14.756 14.756 0 11-20.87 0 14.754 14.754 0 0120.87 0zm0 0l11.027-11.027m0 0l8.049 8.045 9.391-9.39-8.049-8.044m-9.391 9.39l9.391-9.39"
          fill="none"
          strokeLinecap="round"
          strokeWidth={6.1}
          transform="translate(60 792)"
        />
      </g>
    </g>
  </svg>
);
export const tutorsIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g data-name="Group 27254" transform="translate(-527 -743)">
      <circle
        data-name="Ellipse 451"
        cx={96}
        cy={96}
        r={96}
        transform="translate(527 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27249">
        <g data-name="Group 27241">
          <g data-name="Group 27238">
            <g
              data-name="user (1)"
              transform="translate(12 685.631) translate(247 1.831) translate(299 109) translate(0 8.457)"
              fill="#6f75bc"
              stroke="#6f75bc"
              strokeLinejoin="round"
              strokeWidth={1.4}
            >
              <path
                data-name="Path 1"
                d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
              />
              <circle
                data-name="Ellipse 1"
                cx={23.257}
                cy={23.257}
                r={23.257}
                transform="translate(14.535)"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
        <g data-name="Group 27242">
          <g data-name="Group 27208">
            <g
              data-name="Group 27203"
              transform="translate(12 685.631) translate(547.285 -257.879) translate(84 361.248)"
            >
              <rect
                data-name="Rectangle 11634"
                width={45}
                height={52}
                rx={2}
                transform="translate(-.285)"
                fill="none"
                stroke="#6f75bc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={6}
              />
              <path
                data-name="Line 1620"
                transform="translate(13.042 38.819)"
                fill="none"
                stroke="#6f75bc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={6}
                d="M19.829 0L0 0"
              />
              <path
                data-name="check (4)"
                d="M30.155 15.192L19.43 25.916l-4.875-4.874"
                fill="none"
                stroke="#6f75bc"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={6}
                style={{
                  mixBlendMode: "darken",
                  isolation: "isolate",
                }}
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export const assessorIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="assessorIcon"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g data-name="Group 27252" transform="translate(-1020 -743)">
      <circle
        data-name="Ellipse 449"
        cx={96}
        cy={96}
        r={96}
        transform="translate(1020 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27248" transform="translate(11 686)">
        <g data-name="Group 27245">
          <g data-name="Group 27241">
            <g data-name="Group 27238">
              <g
                data-name="user (1)"
                transform="translate(246 -2.859) translate(496 4.462) translate(299 109) translate(0 8.457)"
                fill="currentColor"
                stroke="currentColor"
                strokeLinejoin="round"
                strokeWidth={1.4}
              >
                <path
                  data-name="Path 1"
                  d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
                />
                <circle
                  data-name="Ellipse 1"
                  cx={23.257}
                  cy={23.257}
                  r={23.257}
                  transform="translate(14.535)"
                  strokeLinecap="round"
                />
              </g>
            </g>
          </g>
        </g>
        <path
          data-name="Path 48797"
          d="M1163.959 138.919h-10.555v-2.926l.343 1.171v1.756l-.343-3.388.343-4.666a54.338 54.338 0 011.494-7.205 59.597 59.597 0 011.615-4.9 32.62 32.62 0 011.05-2.442 14.733 14.733 0 001.15-3.149 8.981 8.981 0 00-.747-6.055 9.3 9.3 0 00-16.611 0 9.082 9.082 0 00-.747 6.055 15.9 15.9 0 001.15 3.149 26.244 26.244 0 011.05 2.442 61.273 61.273 0 011.615 4.9 51.282 51.282 0 011.494 7.205l.3 5.127v2.927h-10.636a4.339 4.339 0 00-4.34 4.339v5.066h36.714v-5.066a4.339 4.339 0 00-4.34-4.339z"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth={5}
        />
        <path
          data-name="Line 1623"
          transform="translate(1130.25 157.576)"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth={5}
          d="M0 0L39.359 0"
        />
      </g>
    </g>
  </svg>
);
export const verifierIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g data-name="Group 27255" transform="translate(-280 -743)">
      <circle
        data-name="Ellipse 452"
        cx={96}
        cy={96}
        r={96}
        transform="translate(280 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27250">
        <g data-name="Group 27238">
          <g
            data-name="user (1)"
            transform="translate(11 684.831) translate(299 109) translate(0 8.457)"
            fill="#6f75bc"
            stroke="currentColor"
            strokeLinejoin="round"
            strokeWidth={1.4}
          >
            <path
              data-name="Path 1"
              d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
            />
            <circle
              data-name="Ellipse 1"
              cx={23.257}
              cy={23.257}
              r={23.257}
              transform="translate(14.535)"
              strokeLinecap="round"
            />
          </g>
        </g>
        <g data-name="Group 27239">
          <g
            data-name="Group 20797"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={6}
          >
            <path
              d="M21.922 54.8s21.921-10.957 21.921-27.4V8.221L21.922 0 0 8.221V27.4c0 16.443 21.922 27.4 21.922 27.4z"
              transform="translate(11 684.831) translate(57.999 -422.128) translate(328.199 527.297)"
            />
            <path
              data-name="check (5)"
              d="M31.854 20.077L17.898 34.033l-6.344-6.343"
              transform="translate(11 684.831) translate(57.999 -422.128) translate(328.199 527.297)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export const learnersIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={192}
    height={192}
    viewBox="0 0 192 192"
  >
    <g data-name="Group 27253" transform="translate(-774 -743)">
      <circle
        data-name="Ellipse 450"
        cx={96}
        cy={96}
        r={96}
        transform="translate(774 743)"
        fill="#ededf6"
      />
      <g data-name="Group 27247">
        <g data-name="Group 27241">
          <g data-name="Group 27238">
            <g
              data-name="user (1)"
              transform="translate(10 680.141) translate(496 4.462) translate(299 109) translate(0 8.457)"
              fill="#6f75bc"
              stroke="#6f75bc"
              strokeLinejoin="round"
              strokeWidth={1.4}
            >
              <path
                data-name="Path 1"
                d="M75.584 85.032V73.404c0-12.844-8.46-23.257-18.9-23.257H18.9C8.46 50.147 0 60.559 0 73.404v11.628"
              />
              <circle
                data-name="Ellipse 1"
                cx={23.257}
                cy={23.257}
                r={23.257}
                transform="translate(14.535)"
                strokeLinecap="round"
              />
            </g>
          </g>
        </g>
        <g
          fill="none"
          stroke="#6f75bc"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={6}
        >
          <path
            data-name="Path 10"
            d="M0 0h13.934a9.289 9.289 0 019.289 9.289V41.8a6.967 6.967 0 00-6.967-6.967H0z"
            transform="translate(10 680.141) translate(877.584 109.859)"
          />
          <path
            data-name="Path 11"
            d="M46.446 0H32.512a9.289 9.289 0 00-9.289 9.289V41.8a6.967 6.967 0 016.967-6.967h16.256z"
            transform="translate(10 680.141) translate(877.584 109.859)"
          />
        </g>
      </g>
    </g>
  </svg>
);

export const questionIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={17}
    viewBox="0 0 17 17"
  >
    <g data-name="Group 20469">
      <g
        data-name="Ellipse 424"
        transform="translate(-19302 14547) translate(19302 -14547)"
        fill="none"
        stroke="#6f75bc"
        strokeWidth={1.4}
      >
        <circle cx={8.5} cy={8.5} r={8.5} stroke="none" />
        <circle cx={8.5} cy={8.5} r={7.8} />
      </g>
      <text
        data-name="?"
        transform="translate(-19302 14547) translate(19308 -14534)"
        fill="#6f75bc"
        fontSize={12}
        fontFamily="Lato-Bold, Lato"
        fontWeight={700}
      >
        <tspan x={0} y={0}>
          {"?"}
        </tspan>
      </text>
    </g>
  </svg>
);

export const usefulNoteIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12.2}
    viewBox="0 0 12 12.2"
  >
    <g data-name="Group 20568" stroke="#f46582">
      <g
        data-name="Ellipse 34"
        fill="rgba(242,244,247,0)"
        strokeWidth={1}
        transform="translate(0 .2)"
      >
        <circle cx={6} cy={6} r={6} stroke="none" />
        <circle cx={6} cy={6} r={5.5} fill="none" />
      </g>
      <text
        transform="translate(0 .2) translate(5 8)"
        fill="#f46582"
        strokeWidth={0.2}
        fontSize={8}
        fontFamily="Nunito-Bold, Nunito"
        fontWeight={700}
      >
        <tspan x={0} y={0}>
          {"i"}
        </tspan>
      </text>
    </g>
  </svg>
);

export const previewContentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13.823}
    height={13.535}
    viewBox="0 0 13.823 13.535"
  >
    <g
      transform="translate(.7 .035)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.4}
    >
      <path
        data-name="Path 21436"
        d="M10.667 7.111v4.267A1.422 1.422 0 019.245 12.8H1.422A1.422 1.422 0 010 11.377V3.555a1.422 1.422 0 011.422-1.422h4.267"
      />
      <path data-name="Path 21437" d="M8.885.747h3.361v3.36" />
      <path
        data-name="Line 123"
        transform="translate(5.133 .955)"
        d="M0 7L7 0"
      />
    </g>
  </svg>
);
export const MaximizeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M15 3h6v6" />
    <path d="M9 21H3v-6" />
    <path d="M21 3l-7 7" />
    <path d="M3 21l7-7" />
  </svg>
);

export const MinimizeIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M4 14h6v6" />
    <path d="M20 10h-6V4" />
    <path d="M14 10l7-7" />
    <path d="M10 14l-7 7" />
  </svg>
);
